/* ==========================================================================
   gcpx: the personalized iPhone case (sections/gcpx-builder.liquid)

   One product, three options (Leather / iPhone Model / Color), in the live
   product page's design. Shared parts are the GCX kit's (assets/gcx-kit.js,
   window.GCX): engraving, chevron rows, typewriter, stickies, cart add,
   language helpers (GCX.tpl, GCX.plural, GCX.slug, GCX.cleanInfo).

   EVERY LANGUAGE. State, rows and URLs hold stable KEYS (leather "croco",
   model "iphone-18-pro-max", color "glossy-black"; from the gcx.i18n_keys
   metafield), never the words shown. The words come from cfg.L / cfg.M /
   cfg.C ({k, n}) and cfg.s (section settings, translated per language):
   templates such as "From [price]" and "[label]: [value]", and plural forms
   {other, one, two, few, many, zero} picked by GCX.plural.

   - Leather and color are always chosen; the iPhone model is not, until the
     shopper picks one (or ?variant= / ?device= names one). Until then the
     price chip reads "From <lowest price of all variants>", the Add to Cart
     and both stickies ask for the model, and ?variant= is left out of the URL.
   - Deep links: ?leather=<key>&color=<key>&device=<key>. The old English names
     ("Croco Glossy", "croco-glossy", "iPhone 17 Pro") and the page language's
     names still work (?colour= too). Keys are what the page writes back.
   - Variant data: the section prints the first 250 variants (Liquid's cap)
     plus the selected leather + iPhone in every color; the rest is fetched 50
     at a time from sections/gcpx-variants.liquid (Section Rendering API).
     Once all rows are in, the page's Product JSON-LD gets the Offers Liquid
     could not list (C6).
   - Cart: ONE /cart/add.js (GCX.cartAdd: XMLHttpRequest, {items:[...]}), the
     case with {Personalization, _personalization_id}, the fee tier for that
     length with {For, _personalization_link}, then the ticked add-ons.
     The Minimalist logo (Oct 2026): its $25 line {_logo_link} first, the case
     with {Logo: "Minimalist", _logo_id} as well.
     Property names are English in every language (the workshop reads them).
   - INITIALS ARE OPTIONAL (OD-3, owner 10 Oct 2026: "Initials optional at the
     advertised price"; docs/cro/initials-optional-2026-10-10). The opening
     total is the case's own price (the Shopping tile and feed price); the
     initials are a "+$33" step (4 characters $44, 5 characters $55 ... 8
     characters $88, $11 a character past three since Oct 2026: the same fee
     tiers). Without initials Add to Cart adds the case alone: one line,
     no fee line, no Personalization properties. With initials the cart is
     exactly as before. Setting the flag below to false brings back the old
     rule (Add to Cart blocked with builder_blocked need_initials);
     scripts/gads_offer_monitor.py reads that declaration.
   ========================================================================== */
(function () {
  "use strict";

  var INI_OPTIONAL = true;

  var root = document.querySelector("[data-gcpx]");
  if (!root) return;
  var cfgEl = root.querySelector("[data-gcpx-config]");
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var S = cfg.s || {};
  var GCX = window.GCX || {};

  /* this page's own flow never carries a drawer personalization */
  window.currentPersonalization = null;

  /* The "Us vs Them" row (sections/gcx-vs, kit): its arrows are placed at 38% of
     the row, 55-70px below the middle of the card photos. On this page (mobile
     arrows "beside", so they sit next to the card, never on it) they are level with
     the photos' middle, measured, whatever the card width (kept up to date when the
     row or the photo is resized, e.g. when the row gains its arrow gutter). */
  (function () {
    var rows = [].slice.call(document.querySelectorAll(".gcx-vs [data-gcx-scroll]"));
    if (!rows.length) return;
    function place(row) {
      var img = row.querySelector("[data-gcx-track] .gcx-vs__img");
      if (!img) return;
      var a = row.getBoundingClientRect(), b = img.getBoundingClientRect();
      if (!b.height) return;
      row.style.setProperty("--gcx-chev-top", Math.round(b.top - a.top + b.height / 2) + "px");
    }
    rows.forEach(function (row) {
      place(row);
      if (!window.ResizeObserver) return;
      var ro = new ResizeObserver(function () { place(row); }), img = row.querySelector("[data-gcx-track] .gcx-vs__img");
      ro.observe(row);
      if (img) ro.observe(img);
    });
  })();

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return [].slice.call((ctx || root).querySelectorAll(sel)); }
  function clean(v) { return GCX.clean ? GCX.clean(v) : String(v || "").replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, maxIni()); }
  function cleanInfo(v) {
    if (GCX.cleanInfo) return GCX.cleanInfo(v);
    var up = String(v || "").toUpperCase(), kept = up.replace(/[^A-Z0-9]/g, "");
    return { value: kept.slice(0, maxIni()), dropped: up.replace(/\s+/g, "").length !== kept.length };
  }
  function isSheet() { return !window.matchMedia("(min-width: 1008px)").matches; }
  function reduced() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
  /* [key] and {key} tokens (the kit's GCX.tpl); unknown tokens stay as written */
  function tpl(s, map) {
    if (GCX.tpl) return GCX.tpl(s, map);
    return String(s == null ? "" : s).replace(/\[([a-z0-9_]+)\]|\{([a-z0-9_]+)\}/gi, function (m, a, b) {
      var k = a || b; return map && map[k] != null ? String(map[k]) : m;
    });
  }
  /* plural forms from the settings ({other, one, two, few, many, zero}); empty forms are left out */
  function forms(o) {
    var out = {};
    if (!o || typeof o !== "object") return { other: String(o || "") };
    for (var k in o) if (o[k] != null && o[k] !== "") out[k] = o[k];
    if (out.other == null) out.other = out.one || "";
    return out;
  }
  function plural(n, o) {
    var f = forms(o);
    if (GCX.plural) return GCX.plural(n, f);
    return tpl(n === 1 && f.one != null ? f.one : f.other, { n: n, count: n });
  }
  function slug(s) {
    if (GCX.slug) return GCX.slug(s);
    var v = String(s == null ? "" : s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return v || null;
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ------------------------------------------------------------- money */
  var MF = (window.theme && window.theme.moneyFormat) || "${{amount}}";
  function fmt(cents) {
    cents = Math.round(Number(cents) || 0);
    function group(n, d, t, s) {
      var p = (n / 100).toFixed(d).split(".");
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] && +p[1] ? s + p[1] : ""); /* no ".00" on a whole amount (owner, 17 Oct 2026) */
    }
    return String(MF).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case "amount_no_decimals": return group(cents, 0, ",", ".");
        case "amount_with_comma_separator": return group(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(cents, 2, "'", ".");
        default: return group(cents, 2, ",", ".");
      }
    }).replace(/<[^>]*>/g, "");
  }
  /* a price, model name or initials inside a sentence is bidi-isolated (FSI ... PDI,
     invisible), so "من $65.00" keeps "$65.00" whole in Arabic and Hebrew */
  function iso(s) { return s ? "\u2068" + s + "\u2069" : s; }
  function fromText(cents) { return tpl(S.fromPrice || "[price]", { price: iso(fmt(cents)) }); }
  var fromTplIso = String(S.fromPrice || "[price]").replace("[price]", "\u2068[price]\u2069");

  /* ------------------------------------------------------------- words for keys */
  var L = cfg.L || [], M = cfg.M || [], C = cfg.C || [];
  function index(list) { var o = {}; list.forEach(function (x) { if (x && x.k != null) o[x.k] = x; }); return o; }
  var Lk = index(L), Mk = index(M), Ck = index(C);
  function nameL(k) { return k && Lk[k] ? Lk[k].n : (cfg.hasL ? "" : cfg.single || ""); }
  function nameM(k) { return k && Mk[k] ? Mk[k].n : ""; }
  function nameC(k) { return k && Ck[k] ? Ck[k].n : ""; }
  function fam(k) { return k && Ck[k] ? Ck[k].f || k : k; }
  function series(k) { return k && Mk[k] ? Mk[k].s || 0 : 0; }
  function labelValue(label, value) { return tpl(S.labelValue || "[label]: [value]", { label: label, value: value }); }

  /* ------------------------------------------------------------- data */
  var rows = [], byId = {};
  function addRow(r) {
    if (!r) return;
    var had = byId[r[0]];
    if (had) { if (!had.sku && r[7]) had.sku = String(r[7]); if (!had.cp && r[9]) had.cp = Number(r[9]) || 0; return; }
    /* lo: Liquid's flag (tracked, policy DENY, 0 < quantity <= cfg.lowAt); never a count */
    /* cp: the compare-at price (row index 9, OD-3), 0 when there is none */
    var v = { id: r[0], l: String(r[1]), m: String(r[2]), c: String(r[3]), p: Number(r[4]) || 0, a: !!r[5], mid: r[6], sku: r[7] ? String(r[7]) : "", lo: r[8] === 1, cp: Number(r[9]) || 0 };
    byId[v.id] = v; rows.push(v);
  }
  (cfg.rows || []).forEach(addRow);
  var per = cfg.per || 50;
  var complete = rows.length >= (cfg.n || 0);

  /* The pages of the variant table are fetched ONE AT A TIME: a burst of parallel
     section requests is what the store's firewall answered with 429 / 503 (live
     check, 28 Sep). A failed page is retried after the server's Retry-After (when
     it sends one) or a growing pause; a page that came back is never fetched again. */
  var gotPage = {};
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function fetchPage(p, tries) {
    if (gotPage[p]) return Promise.resolve();
    tries = tries || 0;
    var sep = cfg.url.indexOf("?") === -1 ? "?" : "&", after = 0;
    return fetch(cfg.url + sep + "section_id=gcpx-variants&page=" + p, { credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) {
        if (!r.ok) {
          var ra = parseFloat(r.headers.get("Retry-After"));
          if (isFinite(ra) && ra > 0) after = Math.min(ra, 30) * 1000;
          throw new Error(r.status);
        }
        return r.text();
      })
      .then(function (t) {
        var m = /<script[^>]*data-gcpx-rows[^>]*>([\s\S]*?)<\/script>/.exec(t);
        if (!m) throw new Error("rows");
        var j = JSON.parse(m[1]);
        /* the table's low flags count only when it used this page's threshold */
        var sameLow = j.lowAt === cfg.lowAt;
        (j.rows || []).forEach(function (r) { addRow(sameLow || !r ? r : r.slice(0, 8)); });
        gotPage[p] = true;
      })
      .catch(function (e) {
        if (tries < 3) return wait(after || [1200, 3000, 7000][tries]).then(function () { return fetchPage(p, tries + 1); });
        throw e;
      });
  }
  function inTurn(list) {
    return list.reduce(function (chain, p) { return chain.then(function () { return fetchPage(p, 0); }); }, Promise.resolve());
  }
  function loadRest() {
    if (complete) return Promise.resolve();
    var pages = [], first = Math.floor(250 / per) + 1, last = Math.ceil((cfg.n || 0) / per);
    for (var p = first; p <= last; p++) pages.push(p);
    return inTurn(pages).then(function () {
      /* anything still missing (the first 250 are only a guess of the order): page it all in */
      if (rows.length < cfg.n) {
        var all = [];
        for (var q = 1; q < first; q++) all.push(q);
        return inTurn(all);
      }
    }).then(function () { complete = true; });
  }

  /* The rest of the table. A failed load (a 429 or a challenge page) is never
     final: the promise is dropped, so the next tap that needs the data starts
     a new load, and a few spaced-out retries run on their own meanwhile.
     Pages already fetched are not fetched again. */
  var dataP = null, dataFails = 0, dataTimer = null, onData = [];
  function ensureData() {
    if (complete) return Promise.resolve();
    if (!dataP) {
      clearTimeout(dataTimer);
      dataP = loadRest().then(function () {
        var list = onData; onData = [];
        list.forEach(function (f) { f(); });
      }, function (e) {
        dataP = null;
        dataFails++;
        if (dataFails <= 3) dataTimer = setTimeout(function () { if (!complete && !dataP) ensureData().then(null, function () {}); }, [0, 8000, 20000, 45000][dataFails]);
        throw e;
      });
    }
    return dataP;
  }
  /* true when the rows for leather l (and model m, when given) are not in yet */
  function needsData(l, m) {
    if (complete) return false;
    var hasL = false;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].l !== l) continue;
      hasL = true;
      if (!m || rows[i].m === m) return false;
    }
    return hasL ? !!m : true;
  }

  /* m === "" means "no model picked yet": any model will do for the picture */
  function find(l, m, c) {
    var any = null;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i];
      if (v.l !== l || v.c !== c) continue;
      if (m) { if (v.m === m) return v; continue; }
      if (v.a) return v;
      if (!any) any = v;
    }
    return any;
  }
  function colorsFor(l, m) {
    var out = [], at = {};
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i];
      if (v.l !== l || (m && v.m !== m)) continue;
      if (!(v.c in at)) { at[v.c] = out.length; out.push({ c: v.c, a: v.a, mid: v.mid }); }
      else if (v.a && !out[at[v.c]].a) { out[at[v.c]].a = true; out[at[v.c]].mid = v.mid; }
    }
    return out;
  }
  function modelInfo(l, m) {
    var ex = false, av = false;
    for (var i = 0; i < rows.length; i++) { var v = rows[i]; if (v.l === l && v.m === m) { ex = true; if (v.a) { av = true; break; } } }
    return { ex: ex, av: av };
  }
  /* The price of model m in leather l: in color c when it is available there, else the
     lowest available price of that model in the leather (the color picking that model
     switches to, pickFor). 0 when the model is not available in the leather. */
  function modelPrice(l, m, c) {
    var min = 0;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i];
      if (v.l !== l || v.m !== m || !v.a) continue;
      if (v.c === c) return v.p;
      if (!min || v.p < min) min = v.p;
    }
    return min;
  }
  function leatherInfo(l) {
    var min = 0, av = false;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i]; if (v.l !== l) continue;
      if (v.a) { av = true; if (!min || v.p < min) min = v.p; }
    }
    return { min: min, av: av };
  }
  /* The lowest price of leather l in color c (any iPhone model), for the lines
     that name a leather and color before a model is picked (the "Your case"
     line, the desktop sticky). The product-wide minimum belongs to one leather
     only, so it is never printed next to another. Known only once every row of
     that leather is in: all of them (complete), or a leather that sits wholly
     inside the first 250 variants (cfg.fullL, as the tiles' "From" prices).
     {known:false} until then; {known:true, p:0} when nothing is available. */
  function fromFor(l, c) {
    if (!complete && (cfg.fullL || []).indexOf(l) === -1) return { known: false, p: 0 };
    var min = 0, lmin = 0;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i];
      if (v.l !== l || !v.a) continue;
      if (!lmin || v.p < lmin) lmin = v.p;
      if (v.c === c && (!min || v.p < min)) min = v.p;
    }
    return { known: true, p: c ? min : lmin };
  }
  /* the picture of variant v on the stage: its own studio photo, else the studio photo of its
     leather and color (cfg.studio, by keys), else its own picture (owner, 29 Sep) */
  var studioIds = {};
  (cfg.sids || []).forEach(function (id) { studioIds[String(id)] = 1; });
  function mediaId(v) {
    if (!v) return null;
    if (!cfg.sids || !cfg.sids.length || studioIds[String(v.mid)]) return v.mid;
    return (cfg.studio || {})[v.l + "|" + v.c] || v.mid;
  }
  function mediaUrl(v) { return v && cfg.media ? cfg.media[String(mediaId(v))] || null : null; }
  function sized(u, w) { return String(u || "").replace(/([?&])width=\d+/, "$1width=" + w); }
  function anchorFor(u) {
    var s = String(u || "").toLowerCase(), list = cfg.anchors || [];
    for (var i = 0; i < list.length; i++) if (list[i][0] && s.indexOf(list[i][0]) !== -1) return list[i][1];
    return cfg.anchor || "50,44,38.8,0";
  }

  /* ------------------------------------------------------------- tiers, add-ons */
  function tierFor(n) {
    var f = cfg.fee || [];
    if (n < 1 || !f.length) return null;
    for (var i = 0; i < f.length; i++) if (n <= f[i].max) return f[i];
    return f[f.length - 1];
  }
  /* the longest engraving the fee ladder covers: the section's cfg.maxc, else its top tier */
  function maxIni() {
    if (cfg.maxc > 0) return cfg.maxc;
    var f = cfg.fee || [], m = 0;
    for (var i = 0; i < f.length; i++) if (f[i].max > m) m = f[i].max;
    return m || 5;
  }
  /* the screen protector for this model, by model key (K.addons.protector.by_model) */
  function spFor(m) { var sp = cfg.sp || {}; return m ? sp[m] || null : null; }

  /* ------------------------------------------------------------- the Minimalist logo (owner, 17 Oct 2026)
     The gold GENTCREATE wordmark is left off the outside of the case and pressed into the inside instead, in the same
     place, without foil: the $25 minimalist-logo add-on (cfg.logo: its variant id, price and this product's id). The
     row in step 5 and the indicator on your preview (assets/gc-logo-spot.js: "Logo inside +$25" under the gold
     wordmark; on, one see-through "Logo inside" chip where it was) are one choice, state.logo, and the page's GCLogo
     state is this builder's (GCLogo.own, below the initials field). Offered for a photo that has a logo-free twin
     (this product's map from snippets/gc-logo-free-map.liquid, in the page through snippets/gc-logo-spot-kit.liquid);
     every leather and colour here has one. While it is on, your preview, its thumbnail, the zoom, the colour swatches
     and the sticky bar show the twin; the initials keep the anchor of the photo as shot. The cart: addToCart. */
  var LG = cfg.logo && cfg.logo.id && cfg.logo.pid ? cfg.logo : null;
  var GL = LG ? window.GCLogo || null : null;
  function lgTwin(id) { return GL && id ? GL.twin(LG.pid, id) || "" : ""; }
  function logoOn() { return !!(LG && state.logo); }
  /* the photo of v as the choice has it: its logo-free twin while the logo goes inside, "" otherwise (the photo as shot) */
  function photoUrl(v) {
    var t = logoOn() && v ? lgTwin(mediaId(v)) : "";
    return t ? t + (t.indexOf("?") < 0 ? "?" : "&") + "width=1400" : "";
  }
  var lgRow = $('[data-gcpx-extra-row="logo"]'), lgThumb = $("[data-gcpx-logo-img]");
  var lgShown = false, lgSpot = null, lgSpotId = "", lgRaf = 0, shownMid = null;
  /* a press on the indicator (src "photo"); the row's square goes through the add-ons' own click (5 · add-ons) */
  function lgSet(on, src) {
    on = !!on;
    if (!LG || !!state.logo === on) return;
    state.logo = on;
    gcT({ name: "addon_toggle", addon: "minimal_logo", state: on ? "on" : "off", surface: "case_builder", source: src || "photo" });
    render({ image: false });
  }
  /* every render, before syncExtras: the row, the photo and the indicator follow state.logo */
  function syncLogo() {
    if (!LG) return;
    var v = current(), id = v ? String(mediaId(v)) : "";
    /* a leather or colour whose variants are still loading (a deep link, the rest of the table): no photo to judge by
       yet, so the choice stays as it is until there is one */
    if (!id) return;
    var tw = lgTwin(id);
    /* no logo-free photo of this leather and colour: nothing would show it, so it is not offered (the product page's rule) */
    if (lgRow && lgRow.hidden !== !tw) lgRow.hidden = !tw;
    if (!tw) state.logo = false;
    /* the row's picture is always the logo-free twin of the photo on screen: it shows what it does before a tick */
    if (lgThumb && tw) {
      var bg = 'url("' + tw + (tw.indexOf("?") < 0 ? "?" : "&") + 'width=200")';
      if (lgThumb.__gcpxBg !== bg) { lgThumb.__gcpxBg = bg; lgThumb.style.backgroundImage = bg; }
    }
    var on = logoOn();
    if (on !== lgShown) {
      lgShown = on;
      showCaseImage(v);
      colorKey = "";
      syncColors();
      if (GL && GL.changed) GL.changed(); /* the indicator, and anything listening on the page */
      lgFit(); /* the chip has just appeared or gone: its look at once, not a frame later */
    }
    lgMount(id, tw);
  }
  /* the indicator on your preview: mounted once, moved with the photo (another leather or colour), gone without a twin */
  function lgMount(id, tw) {
    var SP = window.GCLogoSpot, p = tw && GL ? GL.spot(LG.pid, id) : null;
    if (!p || !SP || !shot || !img) {
      if (lgSpot) { lgSpot.destroy(); lgSpot = null; lgSpotId = ""; }
      return;
    }
    if (!lgSpot) {
      lgSpot = SP.mount(shot, img, p, {
        isOn: logoOn,
        toggle: function () { lgSet(!state.logo, "photo"); },
        price: function () { return fmt(LG.p); }
      });
      /* the offer and the chip change size with their words and the width caps, the wordmark's box with the picture:
         measured again when they do */
      if (lgSpot && lgRO) [].forEach.call(lgSpot.el.querySelectorAll(".gc-lgs__spot,.gc-lgs__pill,.gc-lgs__chip"), function (el) { lgRO.observe(el); });
    } else if (id !== lgSpotId) {
      lgSpot.update(p);
    }
    lgSpotId = lgSpot ? id : "";
    lgSideSoon();
  }
  /* The caption under the picture (leather · colour · model) sits, on a phone, where the offer "Logo inside +$25" would
     hang under the wordmark. There the offer goes above the wordmark instead, on the leather between the initials and
     the logo (gcpx-builder.css .gcpx-lgs-up). And where that caption wraps to a second line on a narrow phone it can
     reach the chip on the wordmark's place: the chip then rises just clear of it (--gcpx-lgs-lift). Measured from the
     wordmark's box, so it holds in every language and at every width. */
  var lgRO = LG && window.ResizeObserver ? new ResizeObserver(function () { lgSideSoon(); }) : null;
  function lgSideSoon() {
    if (lgRaf || !lgSpot || !window.requestAnimationFrame) return;
    lgRaf = requestAnimationFrame(function () { lgRaf = 0; lgSide(); });
  }
  function lgSide() {
    lgFit();
    if (!lgSpot || !pickEl || pickEl.hidden) return;
    var L = lgSpot.el, b = lgSpot.button, pill = L.querySelector(".gc-lgs__pill"), chip = L.querySelector(".gc-lgs__chip");
    if (!b.offsetHeight) return;
    var br = b.getBoundingClientRect(), cr = pickEl.getBoundingClientRect();
    if (!cr.height) return;
    var drop = parseFloat(L.style.getPropertyValue("--gc-lgs-drop")) || 0;
    if (pill && pill.offsetHeight) L.classList.toggle("gcpx-lgs-up", br.bottom + 6 + drop + pill.offsetHeight > cr.top - 4);
    var lift = chip && chip.offsetHeight ? Math.max(0, Math.ceil(br.top + br.height / 2 + chip.offsetHeight / 2 - (cr.top - 4))) : 0;
    if (L.style.getPropertyValue("--gcpx-lgs-lift") !== lift + "px") L.style.setProperty("--gcpx-lgs-lift", lift + "px");
  }
  /* The chip, "Logo inside", on this photo, smaller than the product page's (Oct 2026: on a 320px phone it wrapped to
     two lines in ten languages, a tall dark block on the case). It keeps to one line (gcpx-builder.css) in the first
     look that fits the case, two wordmarks wide on these studio photos (1.98 measured), or else the smallest: 0 as on
     the product page, 1 without the x, 2 and 10.5px type, 3 the words alone, 4 and 10px (gcpx-builder.css
     .gcpx-lgs-c1..c4). Layout widths (offsetWidth), so the chip's entrance scale does not count. */
  var LG_LOOKS = [[], ["c1"], ["c1", "c2"], ["c1", "c2", "c3"], ["c1", "c3", "c4"]];
  function lgLook(L, k) {
    ["c1", "c2", "c3", "c4"].forEach(function (c) { L.classList.toggle("gcpx-lgs-" + c, LG_LOOKS[k].indexOf(c) >= 0); });
  }
  function lgFit() {
    var L = lgSpot && lgSpot.el, chip = L && L.querySelector(".gc-lgs__chip");
    if (!chip || !L.classList.contains("is-on")) return;
    var fw = lgSpot.button.offsetWidth; /* the wordmark's frame: 1.12 wordmarks (gc-logo-spot.js WIDEN) */
    if (!fw) return;
    var room = fw / 1.12 * 2 + 0.5, was = L.__gcpxLook || 0, k;
    for (k = 0; k < LG_LOOKS.length; k++) {
      lgLook(L, k);
      var w = chip.offsetWidth;
      if (!w) { lgLook(L, was); return; } /* not laid out (a hidden picture): left as it was */
      if (w <= room) break;
    }
    L.__gcpxLook = Math.min(k, LG_LOOKS.length - 1); /* the last one stays on when none fits */
  }
  function lgNewId() { return "lg" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
  /* gc-logo-sync.js leaves a $25 line alone while its case is on the way (the product page's mark, gc_logo_pending) */
  function lgPending(id, on) {
    if (!id) return;
    try {
      var p = JSON.parse(sessionStorage.getItem("gc_logo_pending") || "{}");
      if (on) p[id] = Date.now(); else delete p[id];
      sessionStorage.setItem("gc_logo_pending", JSON.stringify(p));
    } catch (e) {}
  }
  /* the add failed: a $25 line that went in without its case comes straight back out (one request is all or nothing,
     so there should be none; gc-logo-sync.js would take it out too, once its grace has run). A case that did arrive
     keeps its line. */
  function lgBack(id) {
    if (!id) return;
    lgPending(id, false);
    if (!window.fetch) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(base + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var fee = null, kept = false;
        ((cart && cart.items) || []).forEach(function (it) {
          var p = it.properties || {};
          if (String(p._logo_link || "") === id) fee = it;
          if (String(p._logo_id || "") === id) kept = true;
        });
        if (!fee || kept) return;
        var x = new XMLHttpRequest();
        x.open("POST", base + "cart/change.js");
        x.setRequestHeader("Content-Type", "application/json");
        x.setRequestHeader("Accept", "application/json");
        x.onloadend = function () { try { document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {} };
        x.send(JSON.stringify({ id: fee.key, quantity: 0 }));
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------- elements */
  var stage = $("[data-gcpx-stage]");
  var shot = $("[data-gcpx-shot]");
  var img = $("[data-gcpx-img]");
  var stamp = $("[data-gcpx-stamp]");
  var ex = $("[data-gcpx-ex]"), exImg = $("[data-gcpx-ex-img]"), exIni = $("[data-gcpx-ex-ini]"), exCap = $("[data-gcpx-ex-cap]");
  var pickEl = $("[data-gcpx-pick]");
  var modeBtns = $$("[data-gcpx-mode]");
  var thumbs = $$("[data-gcpx-thumb]");
  var liveThumb = $("[data-gcpx-thumb-live]"), liveThumbEng = $("[data-gcpx-thumb-eng]");
  var leatherBtns = $$("[data-gcpx-leather]");
  var colorsBox = $("[data-gcpx-colors]");
  /* the PDP check disc (spec 6), kept once at start: syncColors empties the
     list while the rest of the table loads, and new swatches are built from this */
  var tickTpl = (function () {
    var t0 = colorsBox && colorsBox.querySelector(".gcpx-swatch__tick");
    if (t0) return t0.cloneNode(true);
    var NS = "http://www.w3.org/2000/svg", s = document.createElementNS(NS, "svg");
    s.setAttribute("class", "gcpx-swatch__tick"); s.setAttribute("viewBox", "0 0 20 20");
    s.setAttribute("width", "14"); s.setAttribute("height", "14");
    s.setAttribute("aria-hidden", "true"); s.setAttribute("focusable", "false");
    var c = document.createElementNS(NS, "circle"); c.setAttribute("cx", "10"); c.setAttribute("cy", "10"); c.setAttribute("r", "10");
    var d = document.createElementNS(NS, "path"); d.setAttribute("d", "M6 10l3 3 5-6"); d.setAttribute("stroke", "#fff");
    d.setAttribute("stroke-width", "2"); d.setAttribute("fill", "none"); d.setAttribute("stroke-linecap", "round"); d.setAttribute("stroke-linejoin", "round");
    s.appendChild(c); s.appendChild(d);
    return s;
  })();
  var stockNote = $("[data-gcpx-stock]");
  var batchEl = $("[data-gcpx-batch]"), batchOut = $("[data-gcpx-batch-out]");
  var devBtn = $("[data-gcpx-device-btn]"), devName = $("[data-gcpx-device-name]");
  var pop = $("[data-gcpx-pop]"), popList = $("[data-gcpx-pop-list]"), scrim = $("[data-gcpx-pop-scrim]");
  var chooseSlab = $("[data-gcpx-choose-slab]");
  var input = $("[data-gcpx-initials]"), hint = $("[data-gcpx-hint]"), count = $("[data-gcpx-count]");
  var tiers = $$("[data-gcpx-tier]");
  var exBtns = { sp: $('[data-gcpx-extra="sp"]'), gift: $('[data-gcpx-extra="gift"]'), prio: $('[data-gcpx-extra="prio"]'), logo: $('[data-gcpx-extra="logo"]') };
  var spRow = $('[data-gcpx-extra-row="sp"]');
  var chip = $("[data-gcpx-price]");
  var totalEl = $("[data-gcpx-total]");
  var atc = $("[data-gcpx-atc]");
  var msg = $("[data-gcpx-msg]");
  var spot = $("[data-gcpx-spot]"), ed = $("[data-gcpx-ed]"), edIn = $("[data-gcpx-ed-in]"), edN = $("[data-gcpx-ed-n]"), edOk = $("[data-gcpx-ed-ok]");
  var sumSlab = $(".gcpx-sumslab"), cfmEl = $("[data-gcpx-confirm]"), cfmAdd = $("[data-gcpx-confirm-add]"), cfmEdit = $("[data-gcpx-confirm-edit]"), cfmLive = $("[data-gcpx-confirm-live]");
  var cfmAnother = $("[data-gcpx-confirm-another]"), nextNote = null, nextLive = $("[data-gcpx-next-live]");

  /* ------------------------------------------------------------- state (keys) */
  var params = new URLSearchParams(window.location.search);
  var selV = byId[cfg.sel] || rows[0];
  var state = {
    l: selV ? selV.l : "", m: cfg.picked && selV ? selV.m : "", c: selV ? selV.c : "",
    ini: "", sp: false, gift: false, prio: false, logo: false
  };
  state.ini = clean(params.get("initials") || "");
  state.sp = params.get("sp") === "1";
  state.gift = params.get("gift") === "1";
  state.prio = params.get("priority") === "1";
  state.logo = params.get("logo") === "1";

  /* ?leather= &device= &color= (also ?colour=, ?model=) preselect. Matched on
     keys, then on the color family, then on the names shown (this language's
     and the English model names), with a Unicode-aware slug; an empty slug
     never matches. A longer English value ("croco-glossy") finds its key
     ("croco"). ?variant= wins, as Shopify already rendered it. */
  function matchIn(list, want) {
    var w = slug(want);
    if (!w) return null;
    var i, x;
    for (i = 0; i < list.length; i++) { x = list[i]; if (x.k === w || slug(x.k) === w) return x.k; }
    for (i = 0; i < list.length; i++) { x = list[i]; if (slug(x.n) === w) return x.k; }
    for (i = 0; i < list.length; i++) { x = list[i]; var k = slug(x.k); if (k && w.indexOf(k + "-") === 0) return x.k; }
    for (i = 0; i < list.length; i++) { x = list[i]; if (x.f && slug(x.f) === w) return x.k; }
    return null;
  }
  var wantL = params.get("leather"), wantM = params.get("device") || params.get("model"), wantC = params.get("color") || params.get("colour");
  var deepLink = !cfg.picked && !!(wantL || wantM || wantC);
  function applyDeepLink() {
    var l = matchIn(L, wantL) || state.l;
    var m = matchIn(M, wantM) || state.m;
    pickFor(l, m, matchIn(C, wantC) || state.c);
  }

  /* choose the best m and c for leather l, keeping what the shopper had */
  var devNote = $("[data-gcpx-devnote]"), swapped = null;
  function pickFor(l, m, c) {
    state.l = l;
    if (m) {
      var asked = m, mi = modelInfo(l, m);
      if (!mi.av) {
        /* same generation first, then anything available */
        var ser = series(m), alt = null, any = null;
        for (var i = 0; i < M.length; i++) {
          var k = M[i].k;
          if (!modelInfo(l, k).av) continue;
          if (!any) any = k;
          if (!alt && ser && series(k) === ser) alt = k;
        }
        if (!mi.ex || alt || any) m = alt || any || m;
      }
      swapped = asked !== m ? { l: l, from: asked, to: m } : null;
    } else {
      swapped = null;
    }
    state.m = m || "";
    var cols = colorsFor(l, state.m), pick = null;
    cols.forEach(function (v) { if (!pick && v.a && v.c === c) pick = v; });
    /* the same color family in another leather ("Glossy Black" <-> "Black") */
    if (!pick) cols.forEach(function (v) { if (!pick && v.a && fam(v.c) === fam(c)) pick = v; });
    if (!pick) cols.forEach(function (v) { if (!pick && v.a) pick = v; });
    if (!pick && cols.length) pick = cols[0];
    state.c = pick ? pick.c : c;
  }
  function current() { return find(state.l, state.m, state.c); }

  /* ------------------------------------------------------------- picture */
  function setsFor(u) { return [700, 1000, 1400, 2000].map(function (w) { return sized(u, w) + " " + w + "w"; }).join(", "); }
  function altFor(l, c) { return tpl(S.imgAlt, { leather: nameL(l), color: nameC(c) }); }
  var shownUrl = null;
  /* analytics (assets/gc-track.js, docs/analytics/events-2026-10-04): each event is one gc:track
     DOM event; gcShot tells it which picture the frame shows, for that picture's screen time */
  /* OD-3: the builder's own events also say whether initials are in, never the initials: initials "yes" / "no" (in the
     dataLayer; GTM forwards it once it maps gc.initials) and initials_len (already forwarded to GA4: 0 = none) */
  var INI_EV = { builder_choice: 1, builder_blocked: 1, builder_add: 1, order_check: 1 };
  function gcT(d) {
    try {
      if (d && INI_EV[d.name] && state) {
        if (d.initials == null) d.initials = state.ini ? "yes" : "no";
        if (d.initials_len == null) d.initials_len = state.ini.length;
      }
      document.dispatchEvent(new CustomEvent("gc:track", { detail: d }));
    } catch (e) {}
  }
  function gcShot() { var v = current(), id = v ? mediaId(v) : null; if (id && shot) gcT({ name: "media_show", el: shot.parentNode, media_id: String(id), media_pos: 1, media_label: img ? img.alt : "", has_initials_spot: true }); }
  function showCaseImage(v) {
    var u = mediaUrl(v);
    if (!img || !u) return;
    var a = anchorFor(u);
    /* the Minimalist logo inside (Oct 2026): the same photo without the gold wordmark, its logo-free twin; the
       initials keep the anchor of the photo as shot */
    u = photoUrl(v) || u;
    if (liveThumb) { var tu = sized(u, 200); if (liveThumb.getAttribute("src") !== tu) liveThumb.src = tu; }
    if (liveThumbEng && GCX.anchor) GCX.anchor(liveThumbEng, a);
    img.alt = altFor(state.l, state.c);
    var file = u.split("?")[0].split("/").pop();
    if (shownUrl === file) return;
    var first = shownUrl === null;
    shownUrl = file;
    /* media_show once per photo: the same photo with or without its wordmark (the logo toggle) is not a new one */
    var mid0 = String(mediaId(v)), sameMid = shownMid === mid0;
    shownMid = mid0;
    if (mode === "preview" && !sameMid) gcShot();
    if (first && (img.currentSrc || img.src || "").indexOf(file) !== -1) { if (GCX.anchor) GCX.anchor(shot, a); return; }
    shot.classList.add("is-leaving");
    var pre = new Image();
    pre.sizes = img.sizes;
    pre.srcset = setsFor(u);
    pre.src = sized(u, 1400);
    var go = function () {
      if (shownUrl !== file) return;
      img.srcset = pre.srcset;
      img.src = pre.src;
      if (GCX.anchor) GCX.anchor(shot, a);
      shot.classList.remove("is-leaving");
    };
    if (pre.decode) pre.decode().then(go, go); else pre.onload = go;
  }

  /* the typewriter's example, faint on the case, until the shopper takes over */
  var ghost = "", edOpen = false;
  var twList = input ? (input.getAttribute("data-gcx-typewriter") || "").split(",").map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean) : [];
  function engraveAll() {
    var t = state.ini || ghost;
    if (GCX.engrave) {
      GCX.engrave(shot, t);
      if (liveThumbEng) GCX.engrave(liveThumbEng, state.ini);
    } else if (stamp) {
      setText(stamp, t);
    }
    if (shot) shot.classList.toggle("gcpx-ghost", !state.ini && !!ghost);
  }
  /* The typed examples appear on the photo only while the photo is on screen (owner review, 30 Sep 2026: INP). Each
     letter redraws the engraving, ~100 ms of main-thread work on a 4x-slowed phone, which also ran while the shopper
     was using the rows further down with the photo out of sight. Back on screen, the photo shows the current example. */
  var shotSeen = true;
  if (shot && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      var on = es[es.length - 1].isIntersecting;
      if (on === shotSeen) return;
      shotSeen = on;
      if (on && !state.ini) engraveAll();
    }).observe(shot);
  }
  if (input && "MutationObserver" in window && twList.length) {
    new MutationObserver(function () {
      var ph = String(input.getAttribute("placeholder") || "").toUpperCase(), g = "";
      if (ph && new RegExp("^[A-Z0-9]{1," + maxIni() + "}$").test(ph)) {
        for (var i = 0; i < twList.length; i++) if (twList[i].indexOf(ph) === 0) { g = ph; break; }
      }
      if ((input.__gcxTw && !input.__gcxTw.running) || edOpen) g = "";
      if (g !== ghost) { ghost = g; if (!state.ini && shotSeen) engraveAll(); }
    }).observe(input, { attributes: true, attributeFilter: ["placeholder"] });
  }

  /* ------------------------------------------------------------- render */
  function syncLeathers() {
    leatherBtns.forEach(function (b) {
      var l = b.getAttribute("data-gcpx-leather"), on = l === state.l;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.tabIndex = on ? 0 : -1;
      if (complete) {
        var inf = leatherInfo(l), fr = b.querySelector("[data-gcpx-leather-from]");
        b.classList.toggle("is-out", !inf.av);
        if (fr) setText(fr, inf.av ? fromText(inf.min) : (S.soldout || ""));
      }
    });
    setText($("[data-gcpx-l-name]"), nameL(state.l));
  }
  function syncModels() {
    if (popList) $$(".Popover__Value", popList).forEach(function (o) {
      var m = o.getAttribute("data-gcpx-device"), inf = modelInfo(state.l, m), on = !!state.m && m === state.m;
      /* before the whole table is in, an unknown model is "not known yet", not "not made" */
      var na = complete ? !inf.av : (inf.ex && !inf.av);
      o.classList.toggle("is-selected", on);
      o.setAttribute("aria-selected", on ? "true" : "false");
      o.classList.toggle("is-na", na);
      /* a sold-out / not-made model is not a "select-value" either: gc-mobile-sticky.js
         would count a tap on it as the model chosen (and later point its tooltip at nothing) */
      if (na) { o.setAttribute("aria-disabled", "true"); o.removeAttribute("data-action"); }
      else { o.removeAttribute("aria-disabled"); o.setAttribute("data-action", "select-value"); }
      /* the model's price in the chosen leather and color, as the Leather Set's model list
         shows it (gcls-set.js renderDevices): a sold-out or not-made model says so instead */
      var pr = na || !m ? 0 : modelPrice(state.l, m, state.c);
      setText(o.querySelector("[data-gcpx-device-note]"), "");
      setText(o.querySelector("[data-gcpx-device-price]"), na ? (inf.ex ? (S.soldout || "") : (S.notMade || "")) : pr ? fmt(pr) : "");
    });
    setText(devName, nameM(state.m) || S.devPh || "");
    if (devBtn) {
      devBtn.classList.toggle("is-empty", !state.m);
      devBtn.setAttribute("aria-label", labelValue(S.model || "", nameM(state.m) || S.devPh || ""));
      devBtn.classList.toggle("is-asking", !!swapped);
    }
    if (devNote) {
      devNote.hidden = !swapped;
      setText(devNote, swapped ? tpl(S.devSwap, { leather: iso(nameL(swapped.l)), from: iso(nameM(swapped.from)), to: iso(nameM(swapped.to)) }) : "");
    }
    root.classList.toggle("gcpx--nomodel", !state.m);
  }
  var colorKey = "";
  function swatchLabel(c, a) { return a ? nameC(c) : tpl(S.swatchOut || "[color]", { color: nameC(c) }); }
  function syncColors() {
    if (!colorsBox) return;
    var cols = colorsFor(state.l, state.m);
    var k = state.l + "|" + state.m + "|" + cols.map(function (v) { return v.c + (v.a ? "+" : "-") + v.mid; }).join(",") + (logoOn() ? "|logo" : "");
    if (k !== colorKey) {
      colorKey = k;
      var keep = {};
      $$(".gcpx-swatchwrap", colorsBox).forEach(function (w) { var b = w.querySelector("[data-gcpx-color]"); if (b) keep[b.getAttribute("data-gcpx-color")] = w; });
      var frag = document.createDocumentFragment();
      cols.forEach(function (v) {
        var w = keep[v.c];
        if (!w) {
          w = document.createElement("span");
          w.className = "gcpx-swatchwrap";
          var b = document.createElement("button");
          b.type = "button"; b.className = "gcpx-swatch"; b.setAttribute("role", "radio");
          b.setAttribute("data-gcpx-color", v.c);
          var im = document.createElement("img"); im.alt = ""; im.width = 60; im.height = 60; im.decoding = "async";
          b.appendChild(im); w.appendChild(b);
        }
        if (!w.querySelector(".gcpx-swatch__tick")) w.appendChild(tickTpl.cloneNode(true));
        var b2 = w.querySelector("[data-gcpx-color]"), u = photoUrl(v) || mediaUrl(v), im2 = b2.querySelector("img");
        if (u && im2) {
          var cur = String(im2.getAttribute("src") || "").split("?")[0];
          if (cur !== u.split("?")[0]) im2.src = sized(u, 120) + "&height=120&crop=center";
        }
        b2.classList.toggle("is-out", !v.a);
        if (!v.a) b2.setAttribute("aria-disabled", "true"); else b2.removeAttribute("aria-disabled");
        var lab = swatchLabel(v.c, v.a);
        b2.setAttribute("aria-label", lab); b2.title = lab;
        frag.appendChild(w);
      });
      colorsBox.textContent = "";
      colorsBox.appendChild(frag);
    }
    var outN = 0;
    $$(".gcpx-swatchwrap", colorsBox).forEach(function (w) {
      var b = w.querySelector("[data-gcpx-color]");
      var on = b.getAttribute("data-gcpx-color") === state.c;
      if (b.classList.contains("is-out")) outN++;
      w.classList.toggle("is-on", on);
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.tabIndex = on ? 0 : -1;
    });
    setText($("[data-gcpx-c-name]"), nameC(state.c));
    if (stockNote) setText(stockNote, outN && state.m ? tpl(S.stockLow, { device: iso(nameM(state.m)) }) : "");
  }
  /* The chosen leather tile and color swatch, in view inside their rows: a
     deep link (?leather=wave), "Choose" in the compare section, or a list
     rebuilt for another leather or model could leave them past the visible
     track. Only when the choice (or the list) changed, so a row the shopper
     is browsing is never pulled back; and only when the item is not already
     clear of the edges and the glass chevrons. Centered; the kit's scroll
     listener then refreshes the chevrons. */
  function reveal(el, smooth) {
    var tr = el && el.closest ? el.closest("[data-gcx-track]") : null;
    if (!tr) return;
    var max = tr.scrollWidth - tr.clientWidth;
    if (max < 2) return;
    var R = tr.getBoundingClientRect(), r = el.getBoundingClientRect();
    if (!R.width || !r.width) return;
    var edge = 38, x = tr.scrollLeft;
    var lo = R.left + (x > 2 ? edge : 0), hi = R.right - (x < max - 2 ? edge : 0);
    if (r.left >= lo && r.right <= hi) return;
    var left = Math.max(0, Math.min(max, Math.round(x + (r.left - R.left) - (tr.clientWidth - r.width) / 2)));
    /* in the kit rows' own glide (as their chevrons, kit 1.7.0), else the browser's */
    if (!(smooth && !reduced() && window.GCX && window.GCX.glideTo && window.GCX.glideTo(tr, left))) {
      try { tr.scrollTo({ left: left, behavior: smooth && !reduced() ? "smooth" : "auto" }); } catch (e) { tr.scrollLeft = left; }
    }
    var row = tr.closest("[data-gcx-scroll]");
    if (row && row.__gcxRow) row.__gcxRow.update();
  }
  var shownL = null, shownC = null, shownKey = null;
  function revealChosen() {
    var smooth = shownL !== null;
    if (state.l !== shownL) {
      shownL = state.l;
      reveal(root.querySelector(".gcpx-leather.is-on"), smooth);
    }
    if (state.c !== shownC || colorKey !== shownKey) {
      shownC = state.c; shownKey = colorKey;
      if (colorsBox) reveal(colorsBox.querySelector(".gcpx-swatchwrap.is-on"), smooth);
    }
  }
  function syncPick() {
    setText($("[data-gcpx-pick-l]"), nameL(state.l));
    setText($("[data-gcpx-pick-c]"), nameC(state.c));
    setText($("[data-gcpx-pick-m]"), nameM(state.m));
    var ms = $("[data-gcpx-pick-msep]"); if (ms) ms.hidden = !state.m;
    var d = $("[data-gcpx-pick-ini]");
    if (d) { d.hidden = !state.ini; setText(d, state.ini ? tpl(S.iniQuote || "[initials]", { initials: iso(state.ini) }) : ""); }
  }
  function syncExtras() {
    var sp = spFor(state.m);
    if (spRow) {
      spRow.hidden = !sp;
      if (sp) {
        setText($("[data-gcpx-sp-price]"), fmt(sp.p));
        /* the PDP's protector row has no "?" note; the model is in the name read out */
        if (exBtns.sp) exBtns.sp.setAttribute("aria-label", tpl(S.spAria, { device: nameM(state.m) }));
        var si = $("[data-gcpx-sp-img]"); if (si && sp.img) si.style.backgroundImage = "url('" + sp.img + "')";
      }
    }
    if (!sp) state.sp = false;
    if (!cfg.gift) state.gift = false;
    if (!cfg.prio) state.prio = false;
    ["sp", "gift", "prio", "logo"].forEach(function (k) {
      var b = exBtns[k];
      if (!b) return;
      var lock = !!(inCart[k] && cfg[k]), note = $('[data-gcpx-inbag="' + k + '"]');
      var ck = state[k] || lock ? "true" : "false";
      if (b.getAttribute("aria-checked") !== ck) b.setAttribute("aria-checked", ck);
      if (lock) { b.setAttribute("aria-disabled", "true"); if (note) b.setAttribute("aria-describedby", note.id); }
      else if (b.hasAttribute("aria-disabled")) { b.removeAttribute("aria-disabled"); b.removeAttribute("aria-describedby"); }
      if (note && note.hidden === lock) note.hidden = !lock;
    });
    /* gift packaging the cart already carries cannot be taken off here: no X on its summary line */
    var gx = $('[data-gcpx-line-x="gift"]');
    if (gx && gx.hidden !== !!inCart.gift) gx.hidden = !!inCart.gift;
  }
  /* "Only the letters A-Z and the numbers 0-9 can be stamped." for 3 s, when a
     typed character was dropped (initials are Latin in every language) */
  var latinUntil = 0, latinTimer = null;
  function showLatin() {
    if (!hint || !S.latinOnly) return;
    latinUntil = Date.now() + 3000;
    hint.classList.remove("is-error");
    hint.classList.add("gcx-hint-on");
    setText(hint, S.latinOnly);
    clearTimeout(latinTimer);
    latinTimer = setTimeout(function () { latinUntil = 0; hint.classList.remove("gcx-hint-on"); syncInitials(); }, 3000);
  }
  /* the bar's "8/8  ·  $88": the count, then the fee in its own span, which gcpx-builder.css hides on phones under
     360px so eight wide capitals keep their room in the field (Oct 2026) */
  function edCount(c, p) {
    var pe = edN.querySelector(".gcpx-ed__p");
    if (!pe) {
      edN.textContent = "";
      edN.appendChild(document.createTextNode(""));
      pe = edN.appendChild(document.createElement("span"));
      pe.className = "gcpx-ed__p";
    }
    setText(edN.firstChild, c);
    setText(pe, p);
  }
  function syncInitials() {
    var n = state.ini.length;
    /* not the field a composing keyboard is writing in (see onIni) */
    if (input && input.value !== state.ini && !(iniComposing && document.activeElement === input)) input.value = state.ini;
    if (edIn && edIn.value !== state.ini && !(iniComposing && document.activeElement === edIn)) edIn.value = state.ini;
    var t = tierFor(n);
    if (edN) { edCount(n + "/" + maxIni(), t ? "  ·  " + fmt(t.p) : ""); edN.classList.toggle("is-full", n === maxIni()); }
    if (stage) stage.classList.toggle("gcpx-has-ini", n > 0);
    tiers.forEach(function (el) { el.classList.toggle("is-on", !!t && Number(el.getAttribute("data-gcpx-tier")) === t.max); });
    if (count) { setText(count, n + "/" + maxIni()); count.classList.toggle("is-full", n === maxIni()); }
    if (hint && !hint.classList.contains("is-error") && Date.now() >= latinUntil) setText(hint, t ? tpl(S.tier, { n: n, price: iso(fmt(t.p)) }) : (S.hint || ""));
    engraveAll();
  }
  /* gc-cart-price.js keeps one gift packaging line per giftable item: the case, and the
     screen protector when it is giftable (cfg.spGift) */
  function giftUnits() { return 1 + (cfg.spGift && state.sp && spFor(state.m) ? 1 : 0); }
  /* What the cart already carries (review, 30 Sep 2026). gc-cart-price.js keeps one gift packaging line per
     giftable item once the cart has any gift packaging, and one priority processing line per order. So when the
     cart already has gift packaging, this case is gift-packed and charged for too; when it already has priority
     processing, the whole order has it at no extra charge. The add-on then shows ticked and locked with a short
     note (S.inBag), and the total shows what checkout will charge for this case. Read from /cart.js (readCart). */
  var inCart = { gift: false, prio: false };
  /* quietRender's state (declared here: syncSummary reads it) */
  var quiet = null, holdRoom = false, held = [];
  function giftOn() { return !!cfg.gift && !!(state.gift || inCart.gift); }
  function prioCharged() { return !!cfg.prio && !!state.prio && !inCart.prio; }
  function totals() {
    var v = current(), t = tierFor(state.ini.length);
    var sp = state.sp ? spFor(state.m) : null;
    var total = 0;
    if (state.m && v) total += v.p;
    /* OD-3: the initials fee only once initials are typed (before: the 1-3 character fee was always counted) */
    if (t) total += t.p;
    else if (!INI_OPTIONAL) total += ((cfg.fee || [])[0] || { p: 0 }).p;
    if (sp) total += sp.p;
    if (logoOn()) total += LG.p;
    if (giftOn()) total += cfg.gift.p * giftUnits();
    if (prioCharged()) total += cfg.prio.p;
    return { v: v, t: t, sp: sp, total: total };
  }
  /* The total before a model is picked (owner, 2026-09-29: never a dash): "From" the lowest
     case price in this leather and color, plus the initials fee once initials are typed and
     the add-ons already ticked. While the prices of this leather are still loading (or the
     color is sold out in every model), the product's lowest price stands in: always true
     as a "From". */
  function preTotal() {
    var cf = fromFor(state.l, state.c), t = tierFor(state.ini.length);
    var base = cf.known && cf.p ? cf.p : (cfg.priceMin || 0);
    var total = base + (t ? t.p : 0);
    if (logoOn()) total += LG.p;
    if (giftOn()) total += cfg.gift.p * giftUnits();
    if (prioCharged()) total += cfg.prio.p;
    return total;
  }
  /* the case line's leather, color and model, each in its own span (the check before adding marks them one by one) */
  function fieldsInto(el, parts) {
    if (!el) return;
    var key = parts.join("\u0001");
    if (el.__gcpxKey === key) return;
    el.__gcpxKey = key;
    while (el.firstChild) el.removeChild(el.firstChild);
    parts.forEach(function (t, i) {
      if (i) el.appendChild(document.createTextNode(" · "));
      var sp = document.createElement("span");
      sp.className = "gcpx-f"; sp.setAttribute("data-gcpx-f", ""); sp.textContent = t;
      el.appendChild(sp);
    });
  }
  function syncSummary() {
    var T = totals(), v = T.v, f0 = (cfg.fee || [])[0];
    fieldsInto($("[data-gcpx-line-case-sub]"), [nameL(state.l), nameC(state.c), nameM(state.m)].filter(Boolean));
    var cf = state.m ? null : fromFor(state.l, state.c);
    setText($("[data-gcpx-line-case-p]"), state.m && v ? (v.a ? fmt(v.p) : (S.soldout || ""))
      : !cf.known ? fromText(cfg.priceMin || 0) : cf.p ? fromText(cf.p) : (S.soldout || ""));
    setText($("[data-gcpx-line-ini]"), state.ini);
    /* OD-3: without initials the line adds nothing and says so: S.pzNone ("Not added"; a dash where the language has
       no words for it yet) and S.pzOpt ("Optional · +[price]"; where the language has no words for it: "+[price]",
       never the old "Type your initials above", which reads as a requirement) */
    var pzNone = !T.t && INI_OPTIONAL;
    setText($("[data-gcpx-line-pz-p]"), T.t ? fmt(T.t.p) : pzNone ? (S.pzNone || "—") : (f0 ? fromText(f0.p) : ""));
    setText($("[data-gcpx-line-pz-sub]"), T.t ? plural(state.ini.length, S.pzSubN)
      : pzNone ? (!f0 ? "" : S.pzOpt ? tpl(S.pzOpt, { price: iso(fmt(f0.p)) }) : "+" + iso(fmt(f0.p))) : (S.pzSub || ""));
    var pzLi = $("[data-gcpx-line-pz]");
    if (pzLi) pzLi.classList.toggle("is-none", pzNone);
    var line = function (k, on, p, sub) {
      var li = $("[data-gcpx-line-" + k + "]"); if (!li) return;
      /* a line that goes while the summary is on screen and nobody pressed anything keeps its room, empty (quietRender) */
      if (!on && !li.hidden && (holdRoom || li.classList.contains("is-held"))) {
        if (!li.classList.contains("is-held")) { li.classList.add("is-held"); li.setAttribute("aria-hidden", "true"); held.push(li); }
        return;
      }
      if (li.classList.contains("is-held")) { li.classList.remove("is-held"); li.removeAttribute("aria-hidden"); }
      li.hidden = !on;
      if (on) { setText($("[data-gcpx-line-" + k + "-p]"), fmt(p)); if (sub != null) setText($("[data-gcpx-line-" + k + "-sub]"), sub); }
    };
    line("sp", !!T.sp, T.sp && T.sp.p, nameM(state.m));
    line("logo", logoOn(), LG && LG.p);
    var gu = giftUnits();
    line("gift", giftOn(), cfg.gift && cfg.gift.p * gu, gu > 1 ? plural(gu, S.giftN) : "");
    line("prio", prioCharged(), cfg.prio && cfg.prio.p);
    setText(totalEl, state.m && v ? fmt(T.total) : fromText(preTotal()));

    /* the price chip: "From <lowest of all variants>" until a model is picked,
       in the language's word order (snippets/gcx-price-chip) */
    if (chip) {
      var amt = state.m && v ? fmt(v.p) : fmt(cfg.priceMin);
      if (GCX.priceChip) GCX.priceChip(chip, amt, !state.m);
      else setText(chip.querySelector("[data-gcx-chip-amt]"), amt);
    }
    /* OD-3 / SW-8: next to the chip, the variant's compare-at price struck with the % off (once a model is picked and
       the variant has one: the Shopping tile's "$89, was $115"); under it, what initials add: "+$33 for initials
       (optional)", the typed length's tier once there are initials. The chip's own amount is unchanged. */
    var cmp = $("[data-gcpx-compare]"), save = $("[data-gcpx-save]");
    var cp = state.m && v && v.cp > v.p ? v.cp : 0;
    /* only the amount: the <s> also holds the visually hidden "Was " for screen readers */
    if (cmp) { if (cp) setText($("[data-gcpx-compare-amt]") || cmp, fmt(cp)); if (cmp.hidden !== !cp) cmp.hidden = !cp; }
    /* floored, as the Liquid first paint and the PDP badge (Oct 2026) */
    if (save) { if (cp) setText(save, "−" + Math.floor((cp - v.p) * 100 / cp) + "%"); if (save.hidden !== !cp) save.hidden = !cp; }
    var chipIni = $("[data-gcpx-chip-ini]");
    if (chipIni && INI_OPTIONAL) {
      var ip = T.t ? T.t.p : (f0 ? f0.p : 0), it = ip && S.chipIni ? tpl(S.chipIni, { price: iso(fmt(ip)) }) : "";
      setText(chipIni, it);
      if (chipIni.hidden !== !it) chipIni.hidden = !it;
    }

    /* the main button: the PDP's choose-state until a model is picked */
    var can = !!(state.m && v && v.a);
    if (atc) {
      atc.classList.toggle("gc-needs-selection", !state.m);
      atc.setAttribute("aria-disabled", state.m && !can ? "true" : "false");
      var lab = atc.querySelector("[data-gcpx-atc-label]");
      if (lab) setText(lab, state.m && v && !v.a ? (S.soldout || "") : (S.add || ""));
    }
    syncSticky(v);
  }
  /* ------------------------------------------------------------- small batch, true stock only
     The pill under the price says the craft fact; while the chosen variant is
     truly low (Liquid's flag) it says "Only a few left in this color" instead.
     Before a model is picked: low only when every available variant of this
     leather and color is low, and only once all of them are known. A sold-out
     choice gets one sentence and one tap to the nearest color in stock for the
     same leather and model (real availability). No numbers, ever. */
  function colorLow(l, c) {
    if (!complete && (cfg.fullL || []).indexOf(l) === -1) return false;
    var any = false;
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i];
      if (v.l !== l || v.c !== c || !v.a) continue;
      if (!v.lo) return false;
      any = true;
    }
    return any;
  }
  function nearestColor(l, m, c) {
    var cols = colorsFor(l, m), at = -1, best = null, bd = 1e9;
    for (var i = 0; i < cols.length; i++) if (cols[i].c === c) at = i;
    cols.forEach(function (x, i) {
      if (!x.a || x.c === c) return;
      var d = at < 0 ? i : Math.abs(i - at);
      if (d < bd) { bd = d; best = x; }
    });
    return best;
  }
  function syncBatch() {
    var v = current();
    var low = state.m ? !!(v && v.a && v.lo) : colorLow(state.l, state.c);
    if (batchEl && GCX.batch) GCX.batch(batchEl, low);
    var out = !!(state.m && v && !v.a);
    if (batchOut && GCX.batchOut) {
      var nb = out ? nearestColor(state.l, state.m, state.c) : null, nu = nb ? photoUrl(nb) || mediaUrl(nb) : null;
      GCX.batchOut(batchOut, {
        show: out,
        text: tpl(S.batchOut || "", { device: iso(nameM(state.m)), color: iso(nameC(state.c)) }),
        pick: nb ? { key: nb.c, label: tpl(S.batchPick || "[color]", { color: nameC(nb.c) }), img: nu ? sized(nu, 120) : "" } : null
      });
      /* the note says it for the chosen color; the general line would repeat it */
      if (stockNote) stockNote.hidden = out;
    }
  }
  function syncSticky(v) {
    if (!GCX.setSticky) return;
    var u = photoUrl(v) || mediaUrl(v);
    var o = {
      title: S.title || cfg.title,
      image: u ? sized(u, 120) : null,
      imageAlt: "",
      label: S.add,
      soldLabel: S.soldout,
      selectLabel: S.choose,
      fromTpl: fromTplIso
    };
    if (state.m && v) {
      o.price = v.p; o.from = false; o.compareAt = null;
      o.options = [nameL(state.l), nameM(state.m), nameC(state.c)];
      o.available = v.a; o.needsSelection = false;
    } else {
      /* the leather and color are named only next to their own "From" price;
         while it is not known, the bar shows the product-wide one on its own */
      var f = fromFor(state.l, state.c);
      o.from = true; o.compareAt = null;
      if (f.known && f.p) { o.price = f.p; o.options = [nameL(state.l), nameC(state.c)]; }
      else { o.price = cfg.priceMin; o.options = []; }
      o.available = true; o.needsSelection = true;
    }
    GCX.setSticky(o);
  }
  /* the URL holds keys, the same in every language */
  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var v = current();
    var q = new URLSearchParams(window.location.search);
    if (state.m && v) q.set("variant", v.id); else q.delete("variant");
    ["leather", "device", "model", "color", "colour"].forEach(function (k) { q.delete(k); });
    if (!state.m) { if (cfg.hasL && state.l) q.set("leather", state.l); if (state.c) q.set("color", state.c); }
    if (state.ini) q.set("initials", state.ini); else q.delete("initials");
    ["sp", "gift", "logo"].forEach(function (k) { if (state[k]) q.set(k, "1"); else q.delete(k); });
    if (state.prio) q.set("priority", "1"); else q.delete("priority");
    var qs = q.toString();
    try { history.replaceState(history.state, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash); } catch (e) {}
  }
  var urlTouched = false;
  function render(opts) {
    opts = opts || {};
    if (quiet) { opts = joinOpts(quiet, opts); quiet = null; }
    syncLeathers();
    syncModels();
    syncColors();
    revealChosen();
    syncPick();
    syncLogo();
    syncExtras();
    syncInitials();
    syncSummary();
    syncBatch();
    if (opts.image !== false) showCaseImage(current());
    if (opts.url !== false) { urlTouched = true; syncUrl(); }
  }

  /* The rating words, in the plural form of the language for the count (Liquid
     prints the "other" form; data-gcx-count has the count):
     - the note behind the "?" next to the compact chip under the price
       ([data-gcpx-rate-reviews], forms cfg.s.rating);
     - a full chip in a section below that carries its own forms
       (sections/gcpx-reviews: [data-gcpx-rating-forms] around .gcx-rating). */
  function fixRating() {
    var r = root.querySelector(".gcx-rating[data-gcx-count]");
    var n = r ? parseInt(r.getAttribute("data-gcx-count"), 10) : NaN;
    var span = root.querySelector("[data-gcpx-rate-reviews]");
    if (span && S.rating && isFinite(n)) {
      var s1 = plural(n, S.rating);
      if (s1) setText(span, s1);
    }
    $$("[data-gcpx-rating-forms]", document).forEach(function (box) {
      var chipEl = box.querySelector(".gcx-rating[data-gcx-count]"), f = null;
      try { f = JSON.parse(box.getAttribute("data-gcpx-rating-forms")); } catch (e) { return; }
      var k = chipEl ? parseInt(chipEl.getAttribute("data-gcx-count"), 10) : NaN;
      var txt = chipEl && chipEl.querySelector(".gcx-rating__txt");
      if (!isFinite(k) || !txt || !f) return;
      var last = txt.lastChild;
      if (!last || last.nodeType !== 3) return;
      var s2 = plural(k, f);
      if (s2) last.nodeValue = " " + s2;
    });
  }

  /* Waiting for the rest of the table, only when the choice needs it: a
     leather or model whose rows are already here is applied at once (the
     rest refreshes the swatches and prices when it arrives). While waiting:
     a small spinner on the picture and the tapped tile. If the load fails, a
     neutral note next to the choice (never the Add to Cart error line); the
     next tap loads again. Only the latest choice is applied. */
  var reqSeq = 0;
  var waitL = $("[data-gcpx-wait-l]"), waitM = $("[data-gcpx-wait-m]");
  function hideWait() { [waitL, waitM].forEach(function (n) { if (n) { n.hidden = true; setText(n, ""); } }); }
  function showWait(n, t) { hideWait(); if (n) { setText(n, t || ""); n.hidden = !t; } }
  function clearWait() {
    if (shot) shot.classList.remove("is-loading");
    leatherBtns.forEach(function (b) { b.classList.remove("is-wait"); });
  }
  function whenReady(fn, need, el, note, noteText) {
    var my = ++reqSeq;
    /* the shopper's own choice now wins over a deep link still waiting for the table */
    deepWait = false;
    hideWait();
    clearWait();
    if (!need) { fn(); return; }
    if (shot) shot.classList.add("is-loading");
    if (el) el.classList.add("is-wait");
    ensureData().then(function () {
      if (my !== reqSeq) return;
      clearWait(); fn();
    }, function () {
      if (my !== reqSeq) return;
      /* a leather tapped (or chosen from the strip below) was marked at once (tapLeather, afterPaintOnce): nothing
         changed, so the mark, aria-checked and the name go back to the leather still chosen */
      syncLeathers();
      clearWait(); showWait(note, noteText);
    });
  }

  /* ------------------------------------------------------------- gallery modes */
  var exThumbs = thumbs.filter(function (t) { return t.getAttribute("data-gcpx-thumb") !== "preview"; });
  var exAt = 0, mode = "preview";
  var exToggle = root.querySelector('[data-gcpx-mode="examples"]');
  if (!exThumbs.length && exToggle) { var tg = exToggle.closest(".gcx-toggle"); if (tg) tg.hidden = true; }
  function markThumb(t) { thumbs.forEach(function (b) { var on = b === t; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); }); }
  function setMode(mo) {
    mode = mo;
    if (stage) stage.setAttribute("data-mode", mo);
    modeBtns.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-gcpx-mode") === mo ? "true" : "false"); });
    if (ex) ex.hidden = mo !== "examples";
    if (shot) shot.hidden = mo === "examples";
    if (pickEl) pickEl.hidden = mo === "examples";
    if (exCap) exCap.hidden = mo !== "examples";
    if (mo === "preview") { markThumb(thumbs[0]); vidSet(null); gcShot(); }
  }
  /* EXAMPLES: a square frame (object-fit: cover, CSS), the photo loaded with the same
     srcset + sizes as the frame, so a warmed copy is exactly the file the frame will pick.
     While it loads, the thumbnail (already on the page, square crop) shows blurred
     underneath (blur-up), then the sharp photo fades in. The next and previous examples
     are warmed when one is shown, and a thumbnail's photo on hover / focus / after the
     strip is scrolled. The frame never changes size (no layout shift). */
  var exWant = null, warmed = {};
  var exPh = stage ? stage.querySelector("[data-gcpx-ex-ph]") : null;
  var exSizes = exImg ? (exImg.getAttribute("sizes") || "") : "";
  function exLoader(u) {
    var im = new Image();
    if (exSizes) im.sizes = exSizes;
    im.srcset = setsFor(u);
    im.src = sized(u, 1400);
    return im;
  }
  function warmThumb(t) {
    var u = t && t.getAttribute("data-u");
    if (!u || warmed[u]) return;
    warmed[u] = exLoader(u);
  }
  function warmEx(i) {
    if (!exThumbs.length) return;
    warmThumb(exThumbs[(i + exThumbs.length) % exThumbs.length]);
  }
  exThumbs.forEach(function (t) {
    t.addEventListener("pointerenter", function () { warmThumb(t); });
    t.addEventListener("focus", function () { warmThumb(t); });
  });
  (function () {
    var tr = exThumbs.length ? exThumbs[0].parentElement : null, tm = null;
    if (!tr) return;
    tr.addEventListener("scroll", function () {
      clearTimeout(tm);
      tm = setTimeout(function () {
        var box = tr.getBoundingClientRect(), n = 0;
        exThumbs.forEach(function (t) {
          var r = t.getBoundingClientRect();
          if (n < 4 && r.right > box.left && r.left < box.right) { warmThumb(t); n++; }
        });
      }, 250);
    }, { passive: true });
  })();
  /* EXAMPLE VIDEOS (owner-approved, muted), owner 29 Sep: sprinkled among the photos (Liquid);
     a video plays (muted, inline, looping) when its slide is the one shown, the examples are on
     and the stage is on screen (a quarter of it or more), and pauses otherwise (another slide,
     your preview, scrolled away, tab hidden). No play button in the slideshow; a tap (or Enter /
     Space on the focused video) pauses and plays. Quality from the first frame, like the PDP:
     each video has its own player with the 1080p MP4 (data-src, chosen in Liquid; no HLS,
     whose adaptive start is soft for seconds), preload="metadata" and its full-size poster;
     while a video's slide is next to the one shown it buffers ahead (preload="auto"), so
     it starts sharp. Autoplay policy (owner, repeated): it does NOT wait for a click and is
     not gated on prefers-reduced-motion; the slide itself is the pause control. */
  var exVid = ex ? ex.querySelector("[data-gcpx-ex-video]") : null;
  var vidThumb = null, vidUserPaused = false, stageOn = true, players = {}, vidNow = null;
  function vidSrc(t) { return t ? t.getAttribute("data-src") || "" : ""; }
  function vidToggle(v) {
    if (!v || v !== vidNow) return;
    if (v.paused) { vidUserPaused = false; vidPlay(); } else { vidUserPaused = true; v.pause(); }
  }
  /* the player of a video thumbnail (made on first need); ahead: buffer it now */
  function playerFor(t, ahead) {
    var u = vidSrc(t);
    if (!exVid || !u) return null;
    var v = players[u];
    if (!v) {
      var used = false;
      for (var k in players) if (players[k] === exVid) used = true;
      v = used ? exVid.cloneNode(false) : exVid;
      if (used) exVid.parentNode.insertBefore(v, exVid.nextSibling);
      v.hidden = true;
      v.muted = true;
      v.setAttribute("aria-label", t.getAttribute("data-alt") || "");
      v.poster = t.getAttribute("data-u") || "";
      v.preload = ahead ? "auto" : "metadata";
      v.src = u;
      v.addEventListener("playing", function () { if (v === vidNow) ex.classList.add("is-playing"); });
      v.addEventListener("click", function () { vidToggle(v); });
      v.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); vidToggle(v); } });
      players[u] = v;
    } else if (ahead && v.preload !== "auto") {
      v.preload = "auto";
    }
    return v;
  }
  function vidWanted() { return !!(vidNow && mode === "examples" && stageOn && !vidUserPaused && !document.hidden); }
  function vidPlay() {
    if (!vidNow) return;
    var p = vidNow.play();
    if (p && p.catch) p.catch(function () {});
  }
  function vidSync() {
    if (vidWanted()) vidPlay(); else if (vidNow && !vidNow.paused) vidNow.pause();
  }
  /* t: a video thumbnail, or null (a photo, or the examples closed) */
  function vidSet(t) {
    if (!exVid) return;
    if (t !== vidThumb) {
      vidThumb = t;
      vidUserPaused = false;
      ex.classList.remove("is-playing");
      var v = t ? playerFor(t, true) : null;
      for (var k in players) {
        var p = players[k];
        if (p !== v) { if (!p.paused) p.pause(); p.hidden = true; p.removeAttribute("tabindex"); }
      }
      vidNow = v;
      if (v) {
        v.hidden = false;
        v.setAttribute("tabindex", "0");
        if (!v.paused && v.readyState > 2) ex.classList.add("is-playing");
      }
    }
    ex.classList.toggle("is-video", !!t);
    if (stage) { if (t) stage.setAttribute("data-exkind", "video"); else stage.removeAttribute("data-exkind"); }
    vidSync();
  }
  /* the videos on the slides next to i: start buffering them */
  function vidAhead(i) {
    [i - 1, i + 1].forEach(function (j) {
      var t = exThumbs[(j + exThumbs.length) % exThumbs.length];
      if (t && t.getAttribute("data-kind") === "video") playerFor(t, true);
    });
  }
  if (exVid) {
    document.addEventListener("visibilitychange", vidSync);
    if (stage && window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { stageOn = e.isIntersecting && e.intersectionRatio >= 0.25; });
        vidSync();
      }, { threshold: [0, 0.25, 0.5, 1] }).observe(stage);
    }
  }
  function showExample(i) {
    if (!exThumbs.length || !exImg) return;
    exAt = (i + exThumbs.length) % exThumbs.length;
    var t = exThumbs[exAt], u = t.getAttribute("data-u"), ln = t.getAttribute("data-ln") || nameL(t.getAttribute("data-l")) || "", ini = t.getAttribute("data-ini") || "";
    var an = t.getAttribute("data-anchor") || anchorFor(u);
    var ti = t.querySelector("img");
    if (exPh) exPh.style.backgroundImage = ti ? 'url("' + (ti.currentSrc || ti.src).replace(/"/g, "%22") + '")' : "none";
    exImg.alt = t.getAttribute("data-alt") || "";
    if (GCX.engrave) GCX.engrave(ex, ini, an); else setText(exIni, ini);
    var tok = u;
    exWant = tok;
    if (exShown !== tok) exShown = null;
    var pre = warmed[u] || exLoader(u);
    warmed[u] = pre;
    var show = function () {
      if (exWant !== tok) return;
      if (exSizes) exImg.sizes = exSizes;
      exImg.srcset = pre.srcset;
      exImg.src = pre.src;
      var fin = function () { if (exWant === tok) { ex.classList.add("is-in"); exShown = tok; } };
      if (exImg.decode) exImg.decode().then(fin, fin); else fin();
    };
    if (pre.complete && pre.naturalWidth) show();
    else {
      ex.classList.remove("is-in");
      if (pre.decode) pre.decode().then(show, show); else { pre.onload = show; pre.onerror = show; }
    }
    warmEx(exAt + 1); warmEx(exAt - 1);
    var cap = ini ? tpl(S.exCap, { leather: ln, initials: iso(ini) }) : (ln ? tpl(S.exCapReal, { leather: ln }) : "");
    setText(exCap, (cap ? cap + "  ·  " : "") + (exAt + 1) + " / " + exThumbs.length);
    markThumb(t);
    setMode("examples");
    vidSet(t.getAttribute("data-kind") === "video" ? t : null);
    gcT({ name: "media_show", el: ex.parentNode, media_id: (String(u || "").split("?")[0].split("/").pop() || "").replace(/\.[a-z0-9]+$/i, ""), media_pos: exAt + 2, media_label: t.getAttribute("data-alt") || "" });
    vidAhead(exAt);
    centerThumb(t, true);
  }
  /* owner, 29 Sep: the chosen thumbnail glides to the middle of the row, so there is more to see on
     both sides (the row's glass chevrons, kit, show where it can still move); at the ends it stops */
  function centerThumb(t, smooth) {
    var tr = t && t.closest ? t.closest("[data-gcx-track]") : null;
    if (!tr) return;
    var max = tr.scrollWidth - tr.clientWidth;
    if (max < 2) return;
    var R = tr.getBoundingClientRect(), r = t.getBoundingClientRect();
    if (!R.width || !r.width) return;
    var rtl = getComputedStyle(tr).direction === "rtl";
    /* how far the thumbnail's middle is from the row's middle, in scroll units */
    var d = (r.left + r.width / 2) - (R.left + R.width / 2);
    var x = tr.scrollLeft + d;
    x = rtl ? Math.max(-max, Math.min(0, x)) : Math.max(0, Math.min(max, x));
    /* the same glide as the strip's chevrons (kit 1.7.0, owner 2 Oct: smooth, not sudden), else the browser's */
    if (smooth && !reduced() && window.GCX && window.GCX.glideTo && window.GCX.glideTo(tr, x)) return;
    try { tr.scrollTo({ left: x, behavior: smooth && !reduced() ? "smooth" : "auto" }); } catch (e) { tr.scrollLeft = x; }
  }
  function firstExampleFor(l) { for (var i = 0; i < exThumbs.length; i++) if (exThumbs[i].getAttribute("data-l") === l) return i; return 0; }
  /* ------------------------------------------------------------- the stage's track (owner, 29 Sep)
     The stage turns like the standard product page's gallery. The picture shown and the one next to it
     sit side by side on one horizontal track: while a finger or the mouse drags, the track follows it
     1:1, so both pictures are seen mid-swipe (hold halfway and see both). On release it goes on to the
     next picture when dragged past 35% of the width or flicked, with an ease-out (320-420 ms), and springs
     back otherwise; with nothing to turn to, the edge gives a little and springs back. The page still
     scrolls up and down (touch-action: pan-y; the direction is decided after 8px), a tap still opens the
     zoom or pauses a video, and the click that ends a drag is eaten. The arrows, the thumbnails and the
     Your preview / Examples toggle glide the same track. Laid out right to left, it is mirrored (next on
     the left). In Examples it steps through the examples (wrapping); on your preview, the next picture
     is this leather's first example and the previous one the example before it (as before). The picture
     coming in is a light layer (the peek: the example's photo, or a video's poster, with its initials)
     loaded with the frame's own srcset + sizes, so the frame then shows the same file already decoded;
     the neighbors are warmed when a picture is shown. Nothing starts a swipe from the stamp spot, the
     field on the picture (swiping is off while it is open), the toggle, the zoom disc or the arrows.
     INP: a press only records a point; the moves write two transforms in a frame; the frame's own
     change (showExample / setMode) runs after the glide, never inside the tap. */
  var peeks = [], peek = null, glide = null, drag = null, eatClick = false, settleSeq = 0, exShown = null;
  var SWIPE_SKIP = "button,a[href],input,label,select,textarea,[data-gcpx-spot],[data-gcpx-ed],.gcpx-modes,[data-gcx-nodrag]";
  /* the stage's width and direction, kept up to date without reading layout inside a tap (INP) */
  var stageW = stage ? stage.clientWidth : 0, stageDirRtl = !!stage && getComputedStyle(stage).direction === "rtl";
  if (stage && window.ResizeObserver) new ResizeObserver(function (es) { var r = es[0] && es[0].contentRect; if (r && r.width) stageW = Math.round(r.width); }).observe(stage);
  function stageRtl() { return stageDirRtl; }
  function stageWidth() { return stageW || (stage ? stage.clientWidth : 0); }
  /* a tap's own work runs just after the next paint, so the page answers the tap at once (INP) */
  function afterPaint(fn) { requestAnimationFrame(function () { setTimeout(fn, 0); }); }
  function curLayer() { return mode === "examples" ? ex : shot; }
  function setX(el, x) { if (el) el.style.transform = x ? "translate3d(" + x.toFixed(1) + "px,0,0)" : ""; }
  /* the peek layers (at most three: two on the stage mid-glide and the one coming in) */
  function newPeek() {
    var el = document.createElement("div");
    el.className = "gcx-engrave gcx-engrave--bare gcpx-ex gcpx-peek is-in";
    el.setAttribute("aria-hidden", "true");
    el.hidden = true;
    var im = document.createElement("img");
    im.className = "gcx-engrave__img";
    im.alt = "";
    im.width = 1400; im.height = 1400;
    im.decoding = "async";
    im.addEventListener("load", function () { im.style.opacity = ""; });
    var mk = document.createElement("div");
    mk.className = "gcx-engrave__mark";
    var tx = document.createElement("span");
    tx.className = "gcx-engrave__text";
    mk.appendChild(tx);
    el.appendChild(im);
    el.appendChild(mk);
    el.__img = im; el.__tx = tx;
    ex.parentNode.insertBefore(el, ex.nextSibling);
    peeks.push(el);
    return el;
  }
  /* a peek layer that is not one of busy (the layers on the stage) */
  function freePeek(busy) {
    for (var k = 0; k < peeks.length; k++) if (!busy || busy.indexOf(peeks[k]) < 0) return peeks[k];
    return ex ? newPeek() : null;
  }
  /* peek layer el shows example i: its thumbnail at once (already on the page), the photo over it when in */
  function fillPeek(i, el) {
    var n = exThumbs.length;
    if (!n || !el) return;
    peek = el;
    var t = exThumbs[((i % n) + n) % n], u = t.getAttribute("data-u") || "", im = el.__img;
    warmThumb(t);
    if (el.__u === u) return;
    el.__u = u;
    var ti = t.querySelector("img");
    el.style.backgroundImage = ti ? 'url("' + (ti.currentSrc || ti.src).replace(/"/g, "%22") + '")' : "none";
    im.style.opacity = "0";
    if (exSizes) im.sizes = exSizes;
    im.srcset = setsFor(u);
    im.src = sized(u, 1400);
    if (im.complete && im.naturalWidth) im.style.opacity = "";
    var ini = t.getAttribute("data-ini") || "";
    if (GCX.engrave) GCX.engrave(el, ini, t.getAttribute("data-anchor") || anchorFor(u)); else setText(el.__tx, ini);
  }
  function hidePeek() { peeks.forEach(function (p) { p.hidden = true; setX(p, 0); }); }
  /* does layer el show example i now? */
  function layerShows(el, i) {
    if (el === ex) return mode === "examples" && !ex.hidden && exAt === i;
    var t = exThumbs[i];
    return !!(t && el && el !== shot && !el.hidden && el.__u === t.getAttribute("data-u"));
  }
  function canPage() { return mode === "examples" ? exThumbs.length > 1 : exThumbs.length > 0; }
  /* where the stage is headed: a glide under way counts as arrived, so quick taps add up (two quick taps on
     the arrow go two pictures on; Your preview then Examples ends on Examples) */
  function headed() {
    var g = glide && glide.tgt;
    if (g) return g.kind === "ex" ? { mode: "examples", at: g.i } : { mode: "preview", at: exAt };
    return { mode: mode, at: exAt };
  }
  /* dir: +1 the next picture, -1 the previous one (st: from where, default the picture shown) */
  function neighbor(dir, st) {
    var n = exThumbs.length;
    if (!n) return null;
    st = st || { mode: mode, at: exAt };
    if (st.mode === "examples") return { kind: "ex", i: (st.at + dir + n) % n };
    var f = firstExampleFor(state.l);
    return { kind: "ex", i: dir > 0 ? f : (f - 1 + n) % n };
  }
  /* the toggle's and the thumbnails' pressed state, for where the stage is headed */
  function markFor(tgt) {
    var mo = tgt.kind === "preview" ? "preview" : "examples";
    modeBtns.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-gcpx-mode") === mo ? "true" : "false"); });
    markThumb(tgt.kind === "preview" ? thumbs[0] : exThumbs[tgt.i]);
  }
  /* a layer's x now (mid-glide too) */
  function curX(el) {
    try {
      var m = getComputedStyle(el).transform, v = m && m.match(/matrix(3d)?\(([^)]+)\)/);
      if (!v) return 0;
      var p = v[2].split(",");
      return parseFloat(p[v[1] ? 12 : 4]) || 0;
    } catch (e) { return 0; }
  }
  /* the frame's own change, after the glide; the peek stays on top until the frame's photo is decoded */
  function commitTo(tgt, from) {
    if (tgt.kind === "preview") {
      setMode("preview");
      centerThumb(thumbs[0], true);
      setX(shot, 0); setX(ex, 0); hidePeek();
      return;
    }
    if (ex) ex.classList.add("gcpx-ex--snap");
    showExample(tgt.i);
    setX(shot, 0); setX(ex, 0);
    var t0 = Date.now(), my = ++settleSeq;
    (function wait() {
      /* a newer glide or drag took the layers over (it moves this peek with the frame) */
      if (my !== settleSeq) return;
      var ready = ex && exShown === exWant && exImg.complete;
      if (!ready && Date.now() - t0 < 1500) { requestAnimationFrame(wait); return; }
      requestAnimationFrame(function () { if (my !== settleSeq) return; hidePeek(); if (ex) ex.classList.remove("gcpx-ex--snap"); });
    })();
  }
  /* glide the layers of list ({el, from, to}; from left out: where it is) together, then run done. The first
     one is the picture coming to rest (to 0; a spring back: the picture shown). tgt: where it ends. */
  function runGlide(list, ms, done, tgt) {
    var rec = { done: false, tgt: tgt || null, rest: list[0] ? list[0].el : null }, anims = [];
    var ease = "cubic-bezier(.22,.61,.36,1)";
    function stop() {
      rec.done = true;
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      if (glide === rec) glide = null;
    }
    function fin() {
      if (rec.done) return;
      stop();
      list.forEach(function (it) { setX(it.el, it.to); });
      done();
    }
    rec.finish = fin;
    /* stop where the layers are, without the glide's end (a tap during it carries on from there): [{el, x}] */
    rec.halt = function () {
      if (rec.done) return [];
      var now = list.map(function (it) { return { el: it.el, x: curX(it.el) }; });
      stop();
      now.forEach(function (it) { setX(it.el, it.x); });
      return now;
    };
    glide = rec;
    if (!list.length || !list[0].el.animate || ms < 16) { fin(); return rec; }
    list.forEach(function (it) {
      var a = it.from == null ? (it.el.style.transform || "translate3d(0px,0,0)") : "translate3d(" + it.from + "px,0,0)";
      anims.push(it.el.animate([{ transform: a }, { transform: "translate3d(" + it.to + "px,0,0)" }], { duration: ms, easing: ease, fill: "forwards" }));
    });
    anims[0].onfinish = fin;
    setTimeout(fin, ms + 250);
    return rec;
  }
  /* arrows, thumbnails and the toggle: glide to a picture (dir +1 comes in from the end side, -1 from the start side).
     want and dir may be functions of where the stage is headed (headed()), worked out only when this runs, so a
     tap made while a glide is under way counts from that glide's picture, never from the one it is leaving. */
  function slideTo(want, dir) {
    if (!stage || drag) return;
    var st = headed(), tgt = typeof want === "function" ? want(st) : want;
    if (!tgt) return;
    if (typeof dir === "function") dir = dir(st, tgt);
    /* already there, or already on its way there: let it be */
    if (tgt.kind === "preview" ? st.mode === "preview" : (st.mode === "examples" && tgt.i === st.at)) {
      if (!glide && tgt.kind === "preview") setMode("preview");
      return;
    }
    var W = stageWidth();
    if (reduced() || !W) { if (glide) glide.finish(); commitTo(tgt); return; }
    /* where the picture shown goes: left for the next one (right on a right-to-left stage) */
    var side = (dir > 0) !== stageRtl() ? -1 : 1;
    /* the layers on the stage: mid-glide, every layer of that glide where it is now (the glide stops there, and
       this one carries on from there: no jump); else the picture shown (and a peek still over it) */
    var on = [], o = 0, seen = [];
    if (glide) {
      var rest = glide.rest;
      glide.halt().forEach(function (it) { if (it.el === rest) o = it.x; on.push(it); });
    } else on.push({ el: curLayer(), x: 0 });
    peeks.forEach(function (p) { if (!p.hidden) on.push({ el: p, x: curX(p) }); });
    on = on.filter(function (it) {
      if (!it.el || seen.indexOf(it.el) >= 0 || Math.abs(it.x) >= W - 1) return false;
      seen.push(it.el); return true;
    });
    settleSeq++;
    /* the picture coming in: a layer on the stage already showing it (turning back mid-glide), else your
       preview or a free peek, just beyond the picture at rest */
    var inc = null, x0 = o - side * W;
    if (tgt.kind === "preview") inc = shot;
    else on.forEach(function (it) { if (!inc && layerShows(it.el, tgt.i)) inc = it.el; });
    if (!inc) { inc = freePeek(seen); fillPeek(tgt.i, inc); }
    if (!inc) { commitTo(tgt); return; }
    on.forEach(function (it) { if (it.el === inc) x0 = it.x; });
    var list = [{ el: inc, from: x0, to: 0 }];
    on.forEach(function (it) { if (it.el !== inc) list.push({ el: it.el, from: it.x, to: it.x - x0 }); });
    setX(inc, x0);
    inc.hidden = false;
    stage.classList.add("is-gliding");
    markFor(tgt);
    var ms = Math.round(Math.max(320, Math.min(420, 360 * Math.abs(x0) / W)));
    runGlide(list, ms, function () {
      stage.classList.remove("is-gliding");
      commitTo(tgt);
    }, tgt);
  }
  modeBtns.forEach(function (b) {
    if (b.getAttribute("data-gcpx-mode") === "examples") {
      var warmFirst = function () { warmEx(firstExampleFor(state.l)); };
      b.addEventListener("pointerenter", warmFirst);
      b.addEventListener("focus", warmFirst);
      b.addEventListener("pointerdown", warmFirst);
    }
    /* INP: nothing is written inside the tap; the pressed state is set with the glide, just after the next paint */
    b.addEventListener("click", function () {
      var toEx = b.getAttribute("data-gcpx-mode") === "examples";
      afterPaint(function () {
        if (toEx) slideTo(function (st) { return st.mode === "examples" ? null : { kind: "ex", i: firstExampleFor(state.l) }; }, 1);
        else slideTo({ kind: "preview" }, -1);
      });
    });
  });
  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      afterPaint(function () {
        if (t.getAttribute("data-gcpx-thumb") === "preview") { slideTo({ kind: "preview" }, -1); centerThumb(t, true); return; }
        var i = exThumbs.indexOf(t);
        slideTo({ kind: "ex", i: i }, function (st) { return st.mode === "examples" && i < st.at ? -1 : 1; });
      });
    });
  });
  $$("[data-gcpx-ex-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      var d = Number(b.getAttribute("data-gcpx-ex-step")) || 1;
      afterPaint(function () { slideTo(function (st) { return neighbor(d, st); }, d); });
    });
  });
  if (stage) {
    stage.classList.add("gcpx-swipe");
    var rubber = function (dx, W) { var s = dx < 0 ? -1 : 1, a = Math.abs(dx); return s * W * 0.14 * (1 - 1 / (a / (W * 0.35) + 1)) * 2; };
    var paint = function () {
      if (!drag || !drag.on) return;
      drag.raf = 0;
      var dx = drag.dx, W = drag.W;
      if (!drag.can) { setX(drag.cur, rubber(dx, W)); return; }
      var s = dx < 0 ? -1 : dx > 0 ? 1 : 0;
      dx = Math.max(-W, Math.min(W, dx));
      if (!s) { setX(drag.cur, 0); if (drag.pk) drag.pk.hidden = true; return; }
      /* moving left brings the picture on the right: the next one (the previous one right to left) */
      var dir = (s < 0) !== drag.rtl ? 1 : -1;
      if (drag.dir !== dir) {
        drag.dir = dir;
        drag.tgt = neighbor(dir);
        fillPeek(drag.tgt.i, drag.pk);
      }
      setX(drag.cur, dx);
      if (drag.pk) { setX(drag.pk, dx - s * W); drag.pk.hidden = false; }
    };
    var endDrag = function (e, cancel) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag;
      drag = null;
      if (d.raf) cancelAnimationFrame(d.raf);
      if (!d.on) return;
      stage.classList.remove("is-dragging");
      try { if (stage.hasPointerCapture && stage.hasPointerCapture(d.id)) stage.releasePointerCapture(d.id); } catch (err) {}
      /* the click that ends a drag is not a tap (no zoom, no video toggle) */
      eatClick = true;
      setTimeout(function () { eatClick = false; }, 0);
      var W = d.W, dx = Math.max(-W, Math.min(W, d.dx)), s = dx < 0 ? -1 : 1;
      /* the speed over the last 100 ms, px per ms */
      var v = 0, p = d.pts, last = p[p.length - 1];
      for (var k = p.length - 2; k >= 0; k--) { if (last[0] - p[k][0] > 100) { v = (last[1] - p[k][1]) / Math.max(1, last[0] - p[k][0]); break; } if (k === 0) v = (last[1] - p[0][1]) / Math.max(1, last[0] - p[0][0]); }
      var flick = Math.abs(v) > 0.35 && (v < 0 ? -1 : 1) === s && Math.abs(dx) > 14;
      var go = !cancel && d.can && d.tgt && d.pk && (Math.abs(dx) > W * 0.35 || flick);
      if (go) {
        var left = W - Math.abs(dx), ms = Math.round(Math.max(220, Math.min(400, flick ? left / Math.max(Math.abs(v), 1) * 2.2 : 360 * left / W + 160)));
        var tgt = d.tgt;
        runGlide([{ el: d.pk, to: 0 }, { el: d.cur, to: s * W }], ms, function () { commitTo(tgt); }, tgt);
        /* the thumbnail and toggle follow just after the next paint (nothing written in the release itself) */
        afterPaint(function () { if (glide && glide.tgt === tgt) markFor(tgt); });
      } else {
        var back = [{ el: d.cur, to: 0 }];
        if (d.can && d.pk && !d.pk.hidden) back.push({ el: d.pk, to: -s * W });
        runGlide(back, 260, function () { hidePeek(); setX(d.cur, 0); });
      }
    };
    stage.addEventListener("pointerdown", function (e) {
      if (drag || !e.isPrimary || (e.pointerType === "mouse" && (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey))) return;
      if (edOpen || (e.target && e.target.closest && e.target.closest(SWIPE_SKIP))) return;
      if (glide) glide.finish();
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, on: false, raf: 0, pts: [[e.timeStamp, e.clientX]], mouse: e.pointerType === "mouse" };
    });
    stage.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.mouse && !(e.buttons & 1)) { endDrag(e, true); return; }
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        /* up and down: the page scrolls, no swipe */
        if (Math.abs(dy) >= Math.abs(dx) || edOpen) { drag = null; return; }
        drag.on = true;
        drag.W = stageWidth() || 1;
        drag.rtl = stageRtl();
        drag.can = canPage();
        drag.cur = curLayer();
        /* the peek coming in: the one still over the frame after a glide (it takes the neighbor), else a free one;
           the last glide's wait for the frame's photo is over */
        drag.pk = drag.can && ex ? (peek || freePeek([])) : null;
        settleSeq++;
        drag.dir = 0;
        stage.classList.add("is-dragging");
        try { stage.setPointerCapture(drag.id); } catch (err) {}
        try { var sel = window.getSelection && window.getSelection(); if (sel && sel.rangeCount) sel.removeAllRanges(); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
      drag.dx = dx;
      drag.pts.push([e.timeStamp, e.clientX]);
      if (drag.pts.length > 8) drag.pts.shift();
      if (!drag.raf) drag.raf = requestAnimationFrame(paint);
    });
    stage.addEventListener("pointerup", function (e) { endDrag(e, false); });
    stage.addEventListener("pointercancel", function (e) { endDrag(e, true); });
    /* only the stage's own capture ending counts (a touch's implicit capture on the picture ends when the stage takes it) */
    stage.addEventListener("lostpointercapture", function (e) { if (e.target === stage && drag && drag.on && e.pointerId === drag.id) endDrag(e, false); });
    stage.addEventListener("click", function (e) { if (eatClick) { eatClick = false; e.preventDefault(); e.stopPropagation(); } }, true);
    stage.addEventListener("dragstart", function (e) { if (drag || (e.target && e.target.nodeName === "IMG")) e.preventDefault(); });
    /* the pictures next to the one shown are warmed once the page is idle, so a first swipe is never blank */
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    idle(function () { if (exThumbs.length) { var f = firstExampleFor(state.l); warmEx(f); warmEx(f - 1); } });
  }

  /* ------------------------------------------------------------- zoom (owner, 29 Sep)
     Exactly the PDP's zoom: the theme's PhotoSwipe (snippets/gcx-pswp, GCX.zoom in the kit)
     with every picture of the stage: your preview first (the chosen leather and color's
     studio photo, with the initials engraved on it as on the stage), then the example
     photos in the slideshow's order (videos are skipped, like the PDP). It opens on the
     picture shown, from the zoom disc or (desktop, as on the PDP) a click on the picture;
     the stage follows to the picture shown when it closes. */
  (function () {
    var btn = $("[data-gcpx-zoom]");
    if (!btn || !GCX.zoom) return;
    var photos = exThumbs.filter(function (t) { return t.getAttribute("data-kind") !== "video"; });
    function big(u) { return sized(u, 4096); }
    function wh(t) { return [Number(t.getAttribute("data-w")) || 2048, Number(t.getAttribute("data-h")) || Number(t.getAttribute("data-w")) || 2048]; }
    function items() {
      var list = [];
      /* the Minimalist logo inside: your preview zooms as its logo-free twin, the initials where they are (Oct 2026) */
      var v = current(), u0 = mediaUrl(v), u = photoUrl(v) || u0, im = shot ? shot.querySelector("[data-gcpx-img]") : null;
      if (!u && im) u = im.currentSrc || im.getAttribute("src") || "";
      if (u) {
        var d = (cfg.mwh || {})[String(mediaId(v))] || [0, 0];
        list.push({ src: big(u), msrc: im ? (im.currentSrc || im.src) : "", w: d[0] || 2048, h: d[1] || d[0] || 2048,
          ini: state.ini || "", anchor: shot ? shot.getAttribute("data-gcx-anchor") || anchorFor(u0 || u) : anchorFor(u0 || u), kind: "preview" });
      }
      photos.forEach(function (t) {
        var tu = t.getAttribute("data-u"), d = wh(t), ti = t.querySelector("img");
        list.push({ src: big(tu), msrc: ti ? (ti.currentSrc || ti.src) : "", w: d[0], h: d[1],
          ini: t.getAttribute("data-ini") || "", anchor: t.getAttribute("data-anchor") || anchorFor(tu), thumb: t });
      });
      return list;
    }
    function open(from) {
      var list = items();
      if (!list.length) return;
      var at = 0;
      if (mode === "examples") {
        var cur = exThumbs[exAt];
        for (var i = 0; i < list.length; i++) if (list[i].thumb === cur) at = i;
        if (!list[at].thumb) return; /* a video is shown: nothing to zoom */
      }
      GCX.zoom(list, at, {
        from: from,
        bounds: function (i) {
          var it = list[i];
          if (!it) return null;
          if (it.kind === "preview") return mode === "preview" ? shot : null;
          return mode === "examples" && exThumbs[exAt] === it.thumb ? ex : null;
        },
        close: function (i) {
          var it = list[i];
          if (!it || i === at) return;
          if (it.kind === "preview") setMode("preview");
          else if (it.thumb) showExample(exThumbs.indexOf(it.thumb));
        }
      });
    }
    btn.addEventListener("click", function () { open(btn); });
    /* desktop (as the PDP, not on phones and tablets): a click on the picture opens the zoom */
    var frame = stage ? stage.querySelector(".gcpx-frame") : null;
    if (frame) frame.addEventListener("click", function (e) {
      if (!window.matchMedia("(min-width: 1008px)").matches) return;
      if (!e.target.closest || !e.target.closest(".gcx-engrave__img")) return;
      if (mode === "examples" && exThumbs[exAt] && exThumbs[exAt].getAttribute("data-kind") === "video") return;
      open(btn);
    });
  })();

  /* ------------------------------------------------------------- a tap paints first (owner, 30 Sep 2026: smoother leather selection)
     A leather tile or a color swatch shows as chosen in the frame of the tap itself: its ring is a class (a
     pseudo-element fading in, CSS: no layout, no reflow) and aria-checked flips. Everything else the choice
     changes (the photo, prices, the new leather's colors, the summary, the URL) runs right after that frame has
     been painted, so the tap's next paint never waits for it (INP). Taps in a row on one row: only the latest runs. */
  var afterJobs = {};
  function afterPaintOnce(key, fn) {
    var job = afterJobs[key] = {};
    requestAnimationFrame(function () {
      setTimeout(function () { if (afterJobs[key] !== job) return; afterJobs[key] = null; fn(); }, 0);
    });
  }
  function markRadio(list, on, box) {
    list.forEach(function (b) {
      var y = b === on;
      (box ? box(b) : b).classList.toggle("is-on", y);
      if (b.getAttribute("aria-checked") !== (y ? "true" : "false")) b.setAttribute("aria-checked", y ? "true" : "false");
    });
  }

  /* ------------------------------------------------------------- 1 · leather */
  function chooseLeather(l, btn, c) {
    if (!l || !Lk[l]) return;
    if (mode !== "preview") setMode("preview");
    whenReady(function () { pickFor(l, state.m, c || state.c); render(); }, needsData(l, state.m), btn, waitL, S.waitL);
  }
  function tapLeather(b) {
    var l = b.getAttribute("data-gcpx-leather");
    if (!l || !Lk[l]) return;
    gcT({ name: "builder_choice", builder: "case", step: "leather", value_key: l });
    markRadio(leatherBtns, b);
    afterPaintOnce("l", function () { chooseLeather(l, b); });
  }
  leatherBtns.forEach(function (b) { b.addEventListener("click", function () { tapLeather(b); }); });
  function radioKeys(box, sel, pick) {
    if (!box) return;
    box.addEventListener("keydown", function (e) {
      var b = e.target.closest && e.target.closest(sel);
      if (!b) return;
      var step = (e.key === "ArrowRight" || e.key === "ArrowDown") ? 1 : (e.key === "ArrowLeft" || e.key === "ArrowUp") ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var all = $$(sel, box), at = all.indexOf(b);
      for (var k = 1; k <= all.length; k++) {
        var nb = all[(at + step * k + all.length * k) % all.length];
        if (!nb.classList.contains("is-out")) { pick(nb); nb.focus(); break; }
      }
    });
  }
  radioKeys($("[data-gcpx-leathers]"), "[data-gcpx-leather]", tapLeather);

  /* ------------------------------------------------------------- 3 · color (delegated: the swatches are rebuilt) */
  if (colorsBox) {
    var tapColor = function (b) {
      var c = b.getAttribute("data-gcpx-color");
      gcT({ name: "builder_choice", builder: "case", step: "color", value_key: c });
      markRadio($$("[data-gcpx-color]", colorsBox), b, function (x) { return x.parentNode; });
      afterPaintOnce("c", function () {
        if (mode !== "preview") setMode("preview");
        state.c = c;
        render();
      });
    };
    colorsBox.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-gcpx-color]");
      if (!b || b.classList.contains("is-out")) return;
      tapColor(b);
    });
    radioKeys(colorsBox, "[data-gcpx-color]", tapColor);
  }
  /* the sold-out note's one tap: that color, same leather and model; focus goes to its swatch */
  if (batchOut) {
    batchOut.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-gcx-batch-pick]");
      var k = b && b.getAttribute("data-key");
      if (!k) return;
      if (mode !== "preview") setMode("preview");
      state.c = k;
      render();
      var sw = colorsBox && colorsBox.querySelector(".gcpx-swatchwrap.is-on [data-gcpx-color]");
      if (sw) sw.focus();
    });
  }

  /* ------------------------------------------------------------- 2 · iPhone model (the PDP popover) */
  var popOpen = false;
  function opts() { return popList ? [].slice.call(popList.querySelectorAll(".Popover__Value")) : []; }
  function headerBottom() {
    var h = document.querySelector(".Header, #shopify-section-header header, header[role='banner']");
    var r = h ? h.getBoundingClientRect() : null;
    return r && r.bottom > 0 && r.bottom < 200 ? r.bottom : (parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) || 70);
  }
  function placePop() {
    if (!popOpen || !pop) return;
    if (isSheet()) { pop.style.top = ""; pop.style.left = ""; pop.style.width = ""; return; }
    var r = devBtn.getBoundingClientRect();
    var w = Math.max(375, Math.round(r.width));
    pop.style.width = w + "px";
    /* beside the trigger, on its left, as on the PDP; below it when there is no room */
    var left = r.left - w - 18;
    if (left < 12) left = Math.max(12, Math.min(window.innerWidth - w - 12, r.left));
    pop.style.left = Math.round(left) + "px";
    var h = pop.offsetHeight || 360, top0 = headerBottom() + 12;
    var top = r.top + r.height / 2 - h / 2;
    if (left === r.left || left + w > r.left) top = r.bottom + 8;
    top = Math.max(top0, Math.min(window.innerHeight - h - 12, top));
    pop.style.top = Math.round(top) + "px";
  }
  function scrollIntoList(el) {
    var box = popList.getBoundingClientRect(), r = el.getBoundingClientRect();
    if (r.top < box.top) popList.scrollTop -= (box.top - r.top);
    else if (r.bottom > box.bottom) popList.scrollTop += (r.bottom - box.bottom);
  }
  /* Home / End go to the ends from anywhere; an arrow pressed while focus is
     not in the list yet starts from the selected model */
  function move(step) {
    var o = opts().filter(function (x) { return !x.hidden; }); if (!o.length) return;
    var at = o.indexOf(document.activeElement), next;
    if (step <= -9999) next = 0;
    else if (step >= 9999) next = o.length - 1;
    else if (at < 0) {
      var s = o.indexOf(popList.querySelector(".is-selected"));
      next = s >= 0 ? s : (step > 0 ? 0 : o.length - 1);
    } else next = Math.min(o.length - 1, Math.max(0, at + step));
    try { o[next].focus({ preventScroll: true }); } catch (e) { o[next].focus(); }
    scrollIntoList(o[next]);
  }
  /* the list fades in (visibility transition), so focus can only land once
     it is visible: try on the next frames until it does */
  function focusOpt(el) {
    var n = 0;
    (function go() {
      if (!popOpen || !el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      if (document.activeElement === el) { scrollIntoList(el); return; }
      if (++n < 30) requestAnimationFrame(go);
    })();
  }
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); closePop(true); return; }
    if (e.key === "ArrowDown") { e.preventDefault(); move(1); return; }
    if (e.key === "ArrowUp") { e.preventDefault(); move(-1); return; }
    if (e.key === "Home") { e.preventDefault(); move(-9999); return; }
    if (e.key === "End") { e.preventDefault(); move(9999); return; }
    /* Tab: back on the trigger and the list gone at once, then the browser's
       own Tab moves on from the trigger (Shift+Tab: back from it) */
    if (e.key === "Tab") closePop(true, true);
  }
  function onOutside(e) { if (pop.contains(e.target) || devBtn.contains(e.target)) return; closePop(false); }
  function openPop() {
    if (popOpen || !pop) return;
    popOpen = true;
    if (chooseSlab) chooseSlab.classList.add("gcx-popover-live", "gc-popover-live");
    root.classList.add("gcpx--pop");
    pop.hidden = false;
    pop.inert = false;
    pop.removeAttribute("inert");
    void pop.offsetWidth;
    pop.setAttribute("aria-hidden", "false");
    devBtn.setAttribute("aria-expanded", "true");
    if (typeof window.gcGroupPopovers === "function") window.gcGroupPopovers();
    placePop();
    if (scrim && isSheet()) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add("is-open"); }); }
    var sel = popList.querySelector(".is-selected") || opts()[0];
    if (sel) { scrollIntoList(sel); requestAnimationFrame(function () { focusOpt(sel); }); }
    document.addEventListener("keydown", onKey, true);
    document.addEventListener("mousedown", onOutside, true);
    window.addEventListener("resize", placePop);
    window.addEventListener("scroll", placePop, true);
  }
  /* now: hide at once (keyboard Tab), else after the fade. Either way the
     closing list is inert at once, so neither Tab nor a click can land in it. */
  function closePop(focusBack, now) {
    if (!popOpen) return;
    popOpen = false;
    if (focusBack) { try { devBtn.focus({ preventScroll: true }); } catch (e) { devBtn.focus(); } }
    pop.setAttribute("aria-hidden", "true");
    pop.inert = true;
    devBtn.setAttribute("aria-expanded", "false");
    if (scrim) { scrim.classList.remove("is-open"); window.setTimeout(function () { if (!popOpen) scrim.hidden = true; }, 240); }
    document.removeEventListener("keydown", onKey, true);
    document.removeEventListener("mousedown", onOutside, true);
    window.removeEventListener("resize", placePop);
    window.removeEventListener("scroll", placePop, true);
    var finish = function () {
      if (popOpen) return;
      /* out of the layout again, so the closed list can never widen the page */
      pop.hidden = true;
      pop.style.top = ""; pop.style.left = ""; pop.style.width = "";
      if (chooseSlab) chooseSlab.classList.remove("gcx-popover-live", "gc-popover-live");
      root.classList.remove("gcpx--pop");
    };
    if (now) finish(); else window.setTimeout(finish, 260);
  }
  if (devBtn && pop) {
    devBtn.addEventListener("click", function () { if (popOpen) closePop(true); else openPop(); });
    devBtn.addEventListener("keydown", function (e) { if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); openPop(); } });
    var pc = pop.querySelector("[data-gcpx-pop-close]");
    if (pc) pc.addEventListener("click", function () { closePop(true); });
    if (scrim) scrim.addEventListener("click", function () { closePop(false); });
    opts().forEach(function (o) {
      o.addEventListener("click", function () {
        /* gc-mobile-sticky.js counts ANY trusted tap on a .Popover__Value as
           "model chosen" and drops its needs-selection 50 ms later, even on a
           sold-out or not-made model (or while the table is still loading).
           Put the sticky back to this page's real state after that timer. */
        window.setTimeout(function () { syncSticky(current()); }, 90);
        if (o.getAttribute("aria-disabled") === "true") return;
        var m = o.getAttribute("data-gcpx-device");
        gcT({ name: "builder_choice", builder: "case", step: "device", value_key: m });
        closePop(true);
        if (mode !== "preview") setMode("preview");
        say("");
        var go = function () {
          if (!modelInfo(state.l, m).av) { syncModels(); syncSticky(current()); return; }
          pickFor(state.l, m, state.c);
          render();
        };
        whenReady(go, needsData(state.l, m), null, waitM, S.waitM);
      });
    });
  }

  /* ------------------------------------------------------------- 4 · initials (Latin in every language) */
  var urlTimer = null;
  /* one handler for both fields (step 4 and the one on the picture): same cleaning (A-Z 0-9, capitals, up to maxIni(): the top of the fee ladder, 8) */
  /* e.isComposing: a composing keyboard (Gboard writes lowercase letters as a composition) is mid-word; rewriting
     the field then repeats letters (a, ab -> AAB). The state, price and preview follow anyway; compositionend
     cleans the field (9 Oct 2026). syncInitials leaves that field alone too. */
  var iniComposing = false;
  function onIni(el, e) {
    var info = cleanInfo(el.value), v = info.value;
    if (el.value !== v && !(e && e.isComposing)) {
      var pos = el.selectionStart;
      el.value = v;
      try { if (pos != null) el.setSelectionRange(Math.min(pos, v.length), Math.min(pos, v.length)); } catch (e) {}
    }
    state.ini = v;
    gcT({ name: "initials_input", surface: "case_builder", initials_len: v.length });
    if (hint) hint.classList.remove("is-error");
    if (input) input.classList.remove("is-error");
    if (info.dropped) showLatin();
    say("");
    if (mode !== "preview") setMode("preview");
    render({ image: false, url: false });
    clearTimeout(urlTimer);
    urlTimer = setTimeout(syncUrl, 400);
  }
  if (input) {
    input.addEventListener("input", function (e) { onIni(input, e); });
    input.addEventListener("compositionstart", function () { iniComposing = true; });
    input.addEventListener("compositionend", function () { iniComposing = false; onIni(input); });
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); input.blur(); } });
    input.addEventListener("focus", function () { if (ghost) { ghost = ""; engraveAll(); } });
  }

  /* ------------------------------------------------------------- 4b · initials on the picture (owner, 29 Sep)
     The stamp spot (a button over the stamp; "Tap to add your initials" under it while there are none)
     opens a small glass field: under the stamp on wider screens, a bar along the bottom of the picture
     on phones (CSS), so the keyboard never covers it and the gold preview above stays in view. It is
     the step-4 field's twin (same state, cleaning, tiers, summary and URL). Enter, Esc, the tick or
     leaving it closes it; 18px text, so iOS does not zoom. */
  function vvKeep() {
    if (!edOpen || !ed) return;
    var vv = window.visualViewport;
    var r = ed.getBoundingClientRect(), bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    if (r.bottom > bottom - 12) window.scrollBy(0, r.bottom - bottom + 12);
  }
  function placeEd() {
    if (!ed || !spot || !stage) return;
    var S0 = stage.getBoundingClientRect(), r = spot.getBoundingClientRect();
    ed.style.setProperty("--gcpx-ed-x", Math.round(r.left + r.width / 2 - S0.left) + "px");
    ed.style.setProperty("--gcpx-ed-y", Math.round(r.bottom - S0.top + 8) + "px");
  }
  function openEd() {
    if (!ed || !edIn) return;
    gcT({ name: "initials_spot_open", surface: "case_builder", action: state.ini ? "edit" : "add" });
    if (mode !== "preview") setMode("preview");
    edOpen = true;
    if (ghost) { ghost = ""; engraveAll(); }
    placeEd();
    ed.hidden = false;
    if (stage) stage.classList.add("is-editing");
    if (spot) spot.setAttribute("aria-expanded", "true");
    edIn.value = state.ini;
    /* focus inside the tap itself, so phones open the keyboard */
    try { edIn.focus({ preventScroll: true }); } catch (e) { edIn.focus(); }
    try { edIn.setSelectionRange(edIn.value.length, edIn.value.length); } catch (e) {}
    window.setTimeout(vvKeep, 350);
  }
  function closeEd(back) {
    if (!edOpen) return;
    edOpen = false;
    ed.hidden = true;
    if (stage) stage.classList.remove("is-editing");
    if (spot) spot.setAttribute("aria-expanded", "false");
    clearTimeout(urlTimer);
    syncUrl();
    if (back && spot) spot.focus({ preventScroll: true });
  }
  if (spot && ed && edIn) {
    /* while it is open, a press on the spot keeps the focus in the field, so its click closes it (no blur race) */
    spot.addEventListener("pointerdown", function (e) { if (edOpen) e.preventDefault(); });
    spot.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); if (edOpen) closeEd(true); else openEd(); });
    edIn.addEventListener("input", function (e) { onIni(edIn, e); });
    edIn.addEventListener("compositionstart", function () { iniComposing = true; });
    edIn.addEventListener("compositionend", function () { iniComposing = false; onIni(edIn); });
    ed.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || (e.key === "Enter" && e.target === edIn)) { e.preventDefault(); e.stopPropagation(); closeEd(true); }
    });
    /* focus leaving the field or its tick (Tab, Shift+Tab, a press anywhere else) closes it */
    ed.addEventListener("focusout", function (e) {
      if (e.relatedTarget && ed.contains(e.relatedTarget)) return;
      window.setTimeout(function () { if (edOpen && !ed.contains(document.activeElement)) closeEd(false); }, 120);
    });
    /* a tap outside closes it too, also where a tap does not take the focus (iOS keeps it in the field) */
    document.addEventListener("click", function (e) {
      if (!edOpen || !e.target || !e.target.closest || e.target.closest("[data-gcpx-ed],[data-gcpx-spot]")) return;
      closeEd(false);
    }, true);
    if (edOk) {
      /* the tick keeps the focus in the field while pressed (iOS: no blur first), then closes */
      edOk.addEventListener("pointerdown", function (e) { e.preventDefault(); });
      edOk.addEventListener("click", function (e) { e.preventDefault(); closeEd(true); });
    }
    /* a press on the glass around the field (the count, the padding) keeps the focus in the field */
    ed.addEventListener("pointerdown", function (e) { if (e.target !== edIn) e.preventDefault(); });
    ed.addEventListener("click", function (e) { e.stopPropagation(); });
    window.addEventListener("resize", function () { if (edOpen) placeEd(); }, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener("resize", function () { if (edOpen) window.setTimeout(vvKeep, 60); });
  }

  /* ------------------------------------------------------------- the Minimalist logo: the page's one choice (Oct 2026)
     GCLogo (assets/gc-logo-spot.js) asks this builder: anything on the page that reads or flips "logo inside" goes
     through state.logo. Where the indicator's offer hangs (lgSide) is measured again whenever the picture changes size,
     its photo arrives or the indicator's stylesheet does (linked without blocking the first paint). */
  if (LG && GL && GL.own) GL.own({ isOn: logoOn, toggle: function () { lgSet(!state.logo, "page"); } });
  if (LG) {
    if (stage && lgRO) lgRO.observe(stage);
    if (pickEl && lgRO) lgRO.observe(pickEl);
    if (img) img.addEventListener("load", lgSideSoon);
    window.addEventListener("load", lgSideSoon);
    var lgCss = document.querySelector('link[href*="gc-logo-spot.css"]');
    if (lgCss) lgCss.addEventListener("load", function () { setTimeout(lgSideSoon, 0); });
  }

  /* ------------------------------------------------------------- 5 · add-ons (PDP squares) */
  ["sp", "gift", "prio", "logo"].forEach(function (k) {
    var b = exBtns[k];
    if (!b) return;
    b.addEventListener("click", function (e) {
      e.preventDefault();
      if (inCart[k] && cfg[k]) return;
      state[k] = !state[k];
      gcT({ name: "addon_toggle", addon: { sp: "screen_protector", gift: "gift_packaging", prio: "priority_processing", logo: "minimal_logo" }[k], state: state[k] ? "on" : "off", surface: "case_builder" });
      /* the PDP square's short "working" ring, then the tick */
      b.setAttribute("aria-busy", "true");
      render({ image: false });
      window.setTimeout(function () { b.removeAttribute("aria-busy"); }, reduced() ? 0 : 320);
    });
  });
  /* the summary's small X on an optional line (owner, 29 Sep): unticks that add-on right there. The line then
     hides, so the focus moves to the next X still shown, else to the summary itself (never lost to the page). */
  $$("[data-gcpx-line-x]").forEach(function (x) {
    x.addEventListener("click", function (e) {
      e.preventDefault();
      var k = x.getAttribute("data-gcpx-line-x");
      if (!state[k]) return;
      state[k] = false;
      /* INP: nothing is written inside the tap; the add-on's tick, the line, the total and the focus change just
         after the next paint, together */
      afterPaint(function () {
        if (exBtns[k]) exBtns[k].setAttribute("aria-checked", state[k] ? "true" : "false");
        render({ image: false });
        var all = $$("[data-gcpx-line-x]"), at = all.indexOf(x), next = null;
        for (var i = 1; i < all.length && !next; i++) {
          var c = all[(at + i) % all.length], li = c.closest("li");
          if (li && !li.hidden && c !== x) next = c;
        }
        if (!next && sumSlab) { if (!sumSlab.hasAttribute("tabindex")) sumSlab.setAttribute("tabindex", "-1"); next = sumSlab; }
        /* only when the X had the focus (a keyboard or a tap on it), so a later focus elsewhere is never taken back */
        var a = document.activeElement;
        if (next && (a === x || a === document.body || !a)) try { next.focus({ preventScroll: true }); } catch (err) { next.focus(); }
      });
    });
  });

  /* ------------------------------------------------------------- add to cart */
  var busy = false;
  function say(t, ok) { if (msg) { setText(msg, t || ""); msg.classList.toggle("is-ok", !!ok); } }
  function smoothTo(el, block) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduced() ? "auto" : "smooth", block: block || "center" }); } catch (e) { el.scrollIntoView(); }
  }
  function askModel() {
    say(S.needModel || "");
    smoothTo(devBtn, "center");
    if (devBtn) {
      devBtn.classList.add("is-asking");
      window.setTimeout(function () { if (!swapped) devBtn.classList.remove("is-asking"); }, 2400);
    }
    window.setTimeout(function () { if (!state.m) openPop(); }, reduced() ? 0 : 520);
  }
  /* A press that adds nothing (no model, sold out, no initials) must not look
     like it is working: gc-product-upsell.js's capture-phase guard has already
     set aria-busy on the button (cleared only by cart:refresh or after 4 s),
     and the stickies spin until product:added or 1.5-3 s. Cleared right after
     those handlers ran, unless a real add is in flight. */
  function notAdding() {
    window.setTimeout(function () {
      if (busy) return;
      if (atc) atc.removeAttribute("aria-busy");
      [].forEach.call(document.querySelectorAll("[data-sticky-add-to-cart].is-loading, .cust-sticky-btn.is-loading"), function (b) { b.classList.remove("is-loading"); });
    }, 0);
  }
  function addToCart(e, opts) {
    if (e && e.preventDefault) e.preventDefault();
    opts = opts || {};
    if (busy || cfmQuick(e)) return;
    say("");
    if (!state.m) { gcT({ name: "builder_blocked", builder: "case", reason: "choose_device" }); notAdding(); askModel(); return; }
    var v = current();
    if (!v || !v.a) { gcT({ name: "builder_blocked", builder: "case", reason: "sold_out" }); notAdding(); return; }
    var ini = state.ini, t = tierFor(ini.length);
    /* OD-3: no initials is a valid order (the case alone, at its own price). Only INI_OPTIONAL = false blocks it. */
    if (!INI_OPTIONAL && (!ini || !t)) {
      gcT({ name: "builder_blocked", builder: "case", reason: "need_initials" });
      notAdding();
      if (hint) { latinUntil = 0; hint.classList.remove("gcx-hint-on"); setText(hint, S.need || ""); hint.classList.add("is-error"); }
      if (input) {
        input.classList.add("is-error");
        smoothTo(input, "center");
        window.setTimeout(function () { input.focus({ preventScroll: true }); }, reduced() ? 0 : 420);
      }
      return;
    }
    /* typed initials with no fee variant to charge them (every fee variant sold out): never drop the initials silently */
    if (ini && !t) { gcT({ name: "builder_blocked", builder: "case", reason: "initials_unavailable" }); notAdding(); say(S.fail || ""); return; }
    /* the first press (main button or a sticky) checks the summary first; its own Add to Cart adds */
    if (!cfmOpen) { notAdding(); openConfirm(); return; }
    var items;
    if (ini) {
      var link = "p_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
      /* property names are fixed English (orders, workshop), never translated */
      items = [
        { id: v.id, quantity: 1, properties: { Personalization: ini, _personalization_id: link } },
        { id: t.id, quantity: 1, properties: { For: ini, _personalization_link: link } }
      ];
    } else {
      /* OD-3: no initials: the case alone, no fee line and no empty Personalization properties */
      items = [{ id: v.id, quantity: 1 }];
    }
    /* the Minimalist logo travels with this case (Oct 2026): "Logo: Minimalist" (the workshop's words, English in every
       language) and an id on the case line, and FIRST in the request the $25 line carrying that id as _logo_link, as
       the product page and the personalize drawer's "Add all" send it. One request, so the pair arrives together;
       assets/gc-logo-sync.js keeps it together afterwards, and lgBack takes the $25 line out if the add fails. */
    var lgId = logoOn() ? lgNewId() : "";
    if (lgId) {
      var lgQ = items[0].quantity || 1;
      items[0].properties = Object.assign({}, items[0].properties || {}, { Logo: "Minimalist", _logo_id: lgId });
      items.unshift({ id: LG.id, quantity: lgQ, properties: { _logo_link: lgId } });
      lgPending(lgId, true);
    }
    var sp = state.sp ? spFor(state.m) : null;
    if (sp) items.push({ id: sp.id, quantity: 1 });
    if (giftOn()) items.push({ id: cfg.gift.id, quantity: giftUnits() });
    if (prioCharged()) items.push({ id: cfg.prio.id, quantity: 1 });

    gcT({ name: "order_check", surface: "case_builder", action: "confirm", path: opts.another ? "add_another" : "add", initials: ini ? "yes" : "no" });
    busy = true;
    atc.setAttribute("aria-busy", "true");
    var pressed = opts.another ? cfmAnother : cfmAdd;
    if (pressed) pressed.setAttribute("aria-busy", "true");
    var done = function () { busy = false; atc.removeAttribute("aria-busy"); if (pressed) pressed.removeAttribute("aria-busy"); };
    if (!GCX.cartAdd) { done(); closeConfirm(false); focusBack(atc); say(S.fail); return; }
    /* "Add to Cart & personalize another": the same lines, added quietly (the cart count updates, no drawer) */
    GCX.cartAdd(items, opts.another ? { quiet: true } : undefined).then(function () {
      done();
      lgPending(lgId, false);
      gcT({ name: "builder_add", builder: "case", again: !!opts.another, pieces: 1, initials_len: ini.length, initials: ini ? "yes" : "no" });
      if (opts.another) { closeConfirm(false); startAnother(items); return; }
      /* the panel's Add to Cart hides with the check: its focus goes to the main one (the cart drawer,
         opening now, takes it from there if it moves the focus) */
      var had = cfmOpen && cfmEl && cfmEl.contains(document.activeElement);
      closeConfirm(false);
      if (had || !document.activeElement || document.activeElement === document.body) focusBack(atc);
      say(S.added || "", true);
    }, function (err) {
      done();
      lgBack(lgId);
      gcT({ name: "builder_blocked", builder: "case", reason: "cart_error" });
      /* never held in the check: it closes, the error shows where it always has */
      closeConfirm(false);
      try { atc.focus({ preventScroll: true }); } catch (x) {}
      say((err && (err.description || err.message)) || S.fail || "");
      /* No product:added here: custom.js and theme.js open the cart drawer on
         it, which would show an unchanged cart over this message. The
         stickies' spinners are stopped directly instead, and the message is
         brought into view (the add may have come from a sticky). */
      [].forEach.call(document.querySelectorAll("[data-sticky-add-to-cart].is-loading, .cust-sticky-btn.is-loading"), function (b) { b.classList.remove("is-loading"); });
      if (msg) {
        var r = msg.getBoundingClientRect();
        if (r.top < headerBottom() || r.bottom > (window.innerHeight || 0) - 90) smoothTo(msg, "center");
      }
    });
  }
  if (atc) atc.addEventListener("click", addToCart);

  /* ------------------------------------------------------------- check before adding (owner, 29 Sep)
     "When selecting Add to Cart: confirm the summary, scroll to it and showcase it with blur outside, with
     its small fields marked, then show Add to Cart there again to proceed." A personalized case is made
     for one person, so a wrong initial is costly. The first valid press (main button or a sticky; they
     click the main one) glides the summary into view, dims and blurs the rest of the page (one fixed veil,
     ~300 ms in), marks leather, color, model, initials and add-ons one after another (120 ms apart) and
     shows a panel under the summary with Add to Cart and a quiet Edit. That Add to Cart adds exactly as
     before. Esc, Edit or a tap on the veil closes it and gives the focus back to the button pressed. The
     panel lies over the page (absolute) and the veil is fixed: nothing moves (no CLS). Nothing is stored:
     every visit, and every new press after Edit, checks again. Shared look: scratchpad r29e/CONFIRM-LOOK.txt. */
  var cfmOpen = false, cfmOpener = null, veil = null, cfmRole = null, cfmAt = 0;
  /* A quick second tap (a double tap on the bar or the main button) lands on the veil, which would close the check,
     or on the check's own buttons (Add to Cart, Add another, Edit) as they glide past: within 450ms of the check
     opening, timed by the tap itself (Event.timeStamp, the same clock as performance.now()), and within 200ms of the
     page still moving, those taps are ignored (9 Oct 2026). Each ignored tap restarts the window (a triple tap). */
  var cfmMoved = 0;
  function cfmQuick(e) {
    if (!cfmOpen || !e || typeof e.timeStamp !== "number") return false;
    var t = e.timeStamp;
    if (t - cfmAt < 450 || t - cfmMoved < 200) { if (t > cfmAt) cfmAt = t; return true; }
    return false;
  }
  window.addEventListener("scroll", function () { if (cfmOpen) cfmMoved = performance.now(); }, { passive: true });
  function cfmFocusables() {
    return [].slice.call(sumSlab ? sumSlab.querySelectorAll("button:not([disabled]),[href],input,[tabindex]:not([tabindex='-1'])") : [])
      .filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
  }
  function cfmKey(e) {
    if (!cfmOpen) return;
    if (e.key === "Escape") { e.preventDefault(); gcT({ name: "order_check", surface: "case_builder", action: "dismiss" }); closeConfirm(true); return; }
    if (e.key !== "Tab") return;
    var f = cfmFocusables();
    if (!f.length) return;
    var a = document.activeElement, i = f.indexOf(a);
    if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  }
  function openConfirm() {
    if (!sumSlab || !cfmEl) { cfmOpen = true; addToCart(); return; }
    cfmOpen = true;
    cfmAt = performance.now();
    gcT({ name: "order_check", surface: "case_builder", action: "open", path: "add" });
    var a = document.activeElement;
    cfmOpener = a && a !== document.body && a !== sumSlab && !sumSlab.contains(a) ? a : atc;
    if (edOpen) closeEd(false);
    if (!veil) {
      veil = document.createElement("div");
      veil.className = "gcpx-veil";
      veil.setAttribute("aria-hidden", "true");
      veil.addEventListener("click", function (e) { if (cfmQuick(e)) return; gcT({ name: "order_check", surface: "case_builder", action: "dismiss" }); closeConfirm(true); });
      document.body.appendChild(veil);
    }
    veil.hidden = false;
    cfmRole = [sumSlab.getAttribute("role"), sumSlab.getAttribute("aria-labelledby")];
    sumSlab.setAttribute("role", "dialog");
    sumSlab.setAttribute("aria-modal", "true");
    sumSlab.setAttribute("aria-labelledby", "gcpx-confirm-h");
    cfmEl.hidden = false;
    sumSlab.classList.add("is-confirm");
    void veil.offsetWidth;
    veil.classList.add("is-on");
    /* the fields in reading order, marked one after another */
    [].slice.call(sumSlab.querySelectorAll("[data-gcpx-f]")).filter(function (el) {
      return el.textContent.trim() && el.getClientRects().length;
    }).forEach(function (el, i) { el.style.setProperty("--i", i); el.classList.add("is-hl"); });
    /* the summary and its panel in the middle of the screen */
    var r = sumSlab.getBoundingClientRect(), p = cfmEl.getBoundingClientRect();
    var h = Math.max(r.bottom, p.bottom) - r.top, vh = window.innerHeight || 0;
    var y = window.pageYOffset + r.top - Math.max(12, (vh - h) / 2);
    try { window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? "auto" : "smooth" }); } catch (x) { window.scrollTo(0, Math.max(0, y)); }
    var head = $("#gcpx-confirm-h");
    if (head) try { head.focus({ preventScroll: true }); } catch (x) {}
    if (cfmLive) { setText(cfmLive, ""); window.setTimeout(function () { if (cfmOpen) setText(cfmLive, S.confirm || ""); }, 60); }
    document.addEventListener("keydown", cfmKey, true);
  }
  function closeConfirm(back) {
    if (!cfmOpen) return;
    cfmOpen = false;
    document.removeEventListener("keydown", cfmKey, true);
    if (sumSlab) {
      sumSlab.classList.remove("is-confirm");
      if (cfmRole) {
        if (cfmRole[0]) sumSlab.setAttribute("role", cfmRole[0]); else sumSlab.removeAttribute("role");
        if (cfmRole[1]) sumSlab.setAttribute("aria-labelledby", cfmRole[1]);
      }
      sumSlab.removeAttribute("aria-modal");
      [].forEach.call(sumSlab.querySelectorAll(".is-hl"), function (el) { el.classList.remove("is-hl"); });
    }
    if (cfmEl) cfmEl.hidden = true;
    if (cfmLive) setText(cfmLive, "");
    if (veil) {
      veil.classList.remove("is-on");
      var v = veil;
      window.setTimeout(function () { if (!cfmOpen) v.hidden = true; }, reduced() ? 0 : 320);
    }
    if (back) focusBack(cfmOpener);
    cfmOpener = null;
  }
  /* The focus goes back to the button pressed, when it can still take it: the check glides the page to the
     summary, which hides a sticky bar (visibility: hidden, so it keeps its boxes but refuses focus). Else,
     and when the focus did not land, the main Add to Cart takes it. */
  function canFocus(el) {
    if (!el || !el.isConnected || !el.getClientRects().length || el.disabled) return false;
    try { if (el.checkVisibility && !el.checkVisibility({ visibilityProperty: true, checkVisibilityCSS: true })) return false; } catch (x) {}
    var cs = window.getComputedStyle(el);
    return cs.visibility !== "hidden" && cs.display !== "none";
  }
  function focusBack(el) {
    var o = canFocus(el) ? el : atc;
    if (o) try { o.focus({ preventScroll: true }); } catch (x) {}
    if (o !== atc && document.activeElement !== o && atc) try { atc.focus({ preventScroll: true }); } catch (x) {}
  }
  if (cfmAdd) cfmAdd.addEventListener("click", function (e) { e.preventDefault(); if (cfmOpen && !cfmQuick(e)) addToCart(); });

  /* ------------------------------------------------------------- Add to Cart & personalize another (owner, 30 Sep 2026)
     "An option to add to cart & create another personalized case: it adds the current one to the cart and brings
     them to the page again to create another." The check's second button adds exactly the lines its Add to Cart
     would (one request; a double tap or a held Enter adds once: busy), quietly: the cart count and the drawer's
     content update, the drawer stays closed (kit GCX.cartAdd quiet, 1.6.0; with an older kit the button stays
     hidden). Then a fresh case: the initials and the screen protector start empty; gift packaging and priority, when
     the first case had them, show as the cart will apply them (inCart: ticked and locked); leather, color and iPhone model stay as they were (a
     second case is most often for the same phone, or for someone's with the same taste; the model is shown in
     step 2 and one tap changes it). The page glides to the top of the builder, the focus goes to the product
     title, and a short note says so (shown ~4 s, and read out politely). */
  var nextTimer = 0;

  /* ------------------------------------------------------------- redraws nobody pressed for (review, 30 Sep 2026: CLS)
     The fresh case after "personalize another" (its add returns ~1 s after the press) and a cart read that finds
     gift packaging or priority already in the cart can show or hide lines of the summary; everything under it
     (Add to Cart, the delivery and how-it-works strips) would then move with no press behind it: a layout shift
     (0.16 measured with all three add-ons). Such a redraw waits until the summary is below the screen (the glide to
     the top of the builder takes it there on phones and desktops), or runs with the shopper's next press or key
     (a shift then is expected). If the summary is still on screen when the glide is over (a very tall window), the
     redraw runs then with holdRoom: a line that goes keeps its room, empty, until that next press or until the
     summary is below the screen. render() itself takes over a waiting redraw. */
  var quietIO = null, quietArmed = false, quietTimer = 0;
  function joinOpts(a, b) {
    return { image: (a.image === false && b.image === false) ? false : undefined, url: (a.url === false && b.url === false) ? false : undefined };
  }
  function sumBelow() {
    if (!sumSlab || !sumSlab.getClientRects().length) return true;
    return sumSlab.getBoundingClientRect().top >= (window.innerHeight || document.documentElement.clientHeight || 0);
  }
  function settleQuiet() {
    if (quiet) { var o = quiet; quiet = null; render(o); }
    if (held.length) {
      held.forEach(function (li) {
        if (!li.classList.contains("is-held")) return;
        li.classList.remove("is-held"); li.removeAttribute("aria-hidden"); li.hidden = true;
      });
      held = [];
    }
    disarmQuiet();
  }
  function onQuietPress(e) { if (e.isTrusted !== false) settleQuiet(); }
  function armQuiet() {
    if (quietArmed) return;
    quietArmed = true;
    window.addEventListener("pointerdown", onQuietPress, { capture: true, passive: true });
    window.addEventListener("keydown", onQuietPress, true);
    if (sumSlab && "IntersectionObserver" in window) {
      if (!quietIO) quietIO = new IntersectionObserver(function () { if (quietArmed && sumBelow()) settleQuiet(); });
      quietIO.observe(sumSlab);
    }
  }
  function disarmQuiet() {
    if (!quietArmed) return;
    quietArmed = false;
    clearTimeout(quietTimer);
    window.removeEventListener("pointerdown", onQuietPress, { capture: true, passive: true });
    window.removeEventListener("keydown", onQuietPress, true);
    if (quietIO) quietIO.disconnect();
  }
  function quietRender(o, holdAfter) {
    quiet = quiet ? joinOpts(quiet, o || {}) : (o || {});
    if (sumBelow()) { settleQuiet(); return; }
    armQuiet();
    if (holdAfter) {
      clearTimeout(quietTimer);
      quietTimer = window.setTimeout(function () {
        if (!quiet) return;
        if (sumBelow()) { settleQuiet(); return; }
        var o2 = quiet; quiet = null;
        holdRoom = true;
        try { render(o2); } finally { holdRoom = false; }
        if (!held.length) disarmQuiet();
      }, holdAfter);
    }
  }

  /* the cart's add-ons (inCart): read once the page is idle, again on every cart:refresh (the drawer, the
     reconcilers in gc-cart-price.js, our own adds) and on a page restored from the back/forward cache */
  var cartSeq = 0, cartTimer = 0;
  function setInCart(items) {
    var g = false, pr = false;
    (items || []).forEach(function (it) {
      var id = Number(it.variant_id || it.id);
      if (cfg.gift && id === Number(cfg.gift.id)) g = true;
      if (cfg.prio && id === Number(cfg.prio.id)) pr = true;
    });
    if (g === inCart.gift && pr === inCart.prio) return;
    inCart.gift = g; inCart.prio = pr;
    quietRender({ image: false, url: false });
  }
  function readCart() {
    if (!(cfg.gift || cfg.prio) || !window.fetch) return;
    var my = ++cartSeq;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(base + "cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (my === cartSeq && cart && cart.items) setInCart(cart.items); }, function () {});
  }
  function readCartSoon() { clearTimeout(cartTimer); cartTimer = window.setTimeout(readCart, 350); }
  document.addEventListener("cart:refresh", readCartSoon);
  window.addEventListener("pageshow", function (e) { if (e.persisted) readCartSoon(); });
  (function () {
    var go = function () { if ("requestIdleCallback" in window) window.requestIdleCallback(readCart, { timeout: 4000 }); else window.setTimeout(readCart, 1500); };
    if (document.readyState === "complete") go(); else window.addEventListener("load", go, { once: true });
  })();

  function startAnother(added) {
    /* what this add put in the cart is in the cart now (the read after cart:refresh confirms it) */
    (added || []).forEach(function (it) {
      if (cfg.gift && Number(it.id) === Number(cfg.gift.id)) inCart.gift = true;
      if (cfg.prio && Number(it.id) === Number(cfg.prio.id)) inCart.prio = true;
    });
    /* A fresh case: the initials, the screen protector and the Minimalist logo start empty (Oct 2026: the logo is
       this case's, like its initials). Gift packaging and priority are not added a
       second time: when the first case had them, the cart applies them to this one too (gift packaging charged per
       item, priority once per order), and the builder shows them ticked, locked and priced that way (inCart). */
    state.ini = ""; state.sp = false; state.gift = false; state.prio = false; state.logo = false;
    latinUntil = 0;
    if (hint) hint.classList.remove("is-error");
    if (input) input.classList.remove("is-error");
    say("");
    if (edOpen) closeEd(false);
    if (mode !== "preview") setMode("preview");
    var y = root.getBoundingClientRect().top + window.pageYOffset - headerBottom() - 8;
    try { window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? "auto" : "smooth" }); } catch (x) { window.scrollTo(0, Math.max(0, y)); }
    /* the redraw of the fresh case: once the glide has taken the summary below the screen (quietRender) */
    quietRender({}, reduced() ? 60 : 1500);
    var title = $("#gcpx-title");
    if (title) {
      if (!title.hasAttribute("tabindex")) title.setAttribute("tabindex", "-1");
      try { title.focus({ preventScroll: true }); } catch (x) {}
    }
    var t = S.anotherDone || "";
    if (nextLive) { setText(nextLive, ""); window.setTimeout(function () { setText(nextLive, t); }, 60); }
    if (t && !nextNote) {
      /* on <body>: a fixed note inside the glass slabs (backdrop-filter) would be placed by the slab, not the screen */
      nextNote = document.createElement("p");
      nextNote.className = "gcpx-next";
      nextNote.setAttribute("aria-hidden", "true");
      nextNote.hidden = true;
      nextNote.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="#C39C2A"/><path d="M6 10.2l2.7 2.7L14.2 7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span>';
      document.body.appendChild(nextNote);
    }
    if (nextNote && t) {
      setText(nextNote.querySelector("span"), t);
      clearTimeout(nextTimer);
      nextNote.style.top = Math.round(headerBottom() + 12) + "px";
      nextNote.hidden = false;
      void nextNote.offsetWidth;
      nextNote.classList.add("is-on");
      nextTimer = window.setTimeout(function () {
        nextNote.classList.remove("is-on");
        nextTimer = window.setTimeout(function () { nextNote.hidden = true; }, reduced() ? 0 : 300);
      }, 4200);
    }
  }
  if (cfmAnother && S.anotherDone != null && GCX.cartAdd && GCX.cartAdd.quiet) {
    cfmAnother.hidden = false;
    cfmAnother.addEventListener("click", function (e) { e.preventDefault(); if (cfmOpen && !cfmQuick(e)) addToCart(null, { another: true }); });
  }
  if (cfmEdit) cfmEdit.addEventListener("click", function (e) { e.preventDefault(); if (cfmQuick(e)) return; gcT({ name: "order_check", surface: "case_builder", action: "edit" }); closeConfirm(true); });

  /* ------------------------------------------------------------- the sections below */
  function fillBelow() {
    if (!complete) return;
    $$("[data-gcpx-cmp]", document).forEach(function (card) {
      var l = card.getAttribute("data-gcpx-cmp"), inf = leatherInfo(l);
      var el = card.querySelector("[data-gcpx-cmp-from]"), t = el && el.getAttribute("data-tpl");
      setText(el, inf.av ? tpl(t || fromTplIso, { price: fmt(inf.min) }) : (S.soldout || ""));
    });
  }
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-gcpx-choose]");
    if (!b) return;
    var l = b.getAttribute("data-gcpx-choose");
    if (!l || !Lk[l]) return;
    e.preventDefault();
    /* how it works, step 1 (owner, 29 Sep): a leather in the strip comes with the color of its photo.
       The tile shows as chosen now; the photo, prices and colors follow right after this frame (afterPaintOnce, INP) */
    var c = b.getAttribute("data-gcpx-choose-c"), tile = null;
    leatherBtns.forEach(function (x) { if (x.getAttribute("data-gcpx-leather") === l) tile = x; });
    if (tile) markRadio(leatherBtns, tile);
    afterPaintOnce("l", function () { chooseLeather(l, null, c && Ck[c] ? c : null); });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? "auto" : "smooth" });
    /* the keyboard carries on from the chosen leather */
    if (c && tile) try { tile.focus({ preventScroll: true }); } catch (x) {}
  });
  /* how it works, step 2 (owner, 29 Sep): the typed field opens the initials field of step 4. Focus in the
     tap itself (so a phone opens its keyboard; the field is 24px, no iOS zoom), then the page glides to it. */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-gcpx-go-initials]");
    if (!b || !input) return;
    e.preventDefault();
    if (mode !== "preview") setMode("preview");
    try { input.focus({ preventScroll: true }); } catch (x) { input.focus(); }
    /* to the field's slab, in the middle of the screen (an absolute target, so a glide already under way is replaced) */
    var box = input.closest(".gcpx-slab") || input, r = box.getBoundingClientRect();
    var y = window.pageYOffset + r.top - Math.max(headerBottom() + 12, (window.innerHeight - r.height) / 2);
    try { window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? "auto" : "smooth" }); } catch (x) { window.scrollTo(0, Math.max(0, y)); }
  });

  /* ------------------------------------------------------------- structured data (C6)
     Liquid lists only the first 250 variants as Offers in the page's Product
     JSON-LD (snippets/gc-product-schema; product.variants stops at 250). Once
     the whole table is in, the missing Offers are added: the shared fields are
     copied from the first server-rendered Offer (shippingDetails,
     hasMerchantReturnPolicy, seller, validFrom, priceValidUntil,
     priceCurrency, itemCondition); url, price, availability and sku are the
     variant's. The SKU is the variant's own (sections/gcpx-variants), else the
     store's formula PZ-<LEATHER>-<iPhone model>-<Color family>. */
  function skuFor(v) {
    if (v.sku) return v.sku;
    if (!cfg.keys || !Mk[v.m] || !v.l) return "";
    var f = String(fam(v.c) || "").split("-").map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join("-");
    return "PZ-" + v.l.toUpperCase() + "-" + String(Mk[v.m].n).trim().replace(/\s+/g, "-") + "-" + f;
  }
  var offersDone = false;
  function completeOffers() {
    if (offersDone || !complete) return;
    offersDone = true;
    try {
      var el = null, data = null, ss = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < ss.length && !el; i++) {
        var d = null;
        try { d = JSON.parse(ss[i].textContent); } catch (e) { continue; }
        if (d && d["@type"] === "Product" && Array.isArray(d.offers) && d.offers.length) { el = ss[i]; data = d; }
      }
      if (!el) return;
      var have = {};
      data.offers.forEach(function (o) { var m = /[?&]variant=(\d+)/.exec(o.url || ""); if (m) have[m[1]] = 1; });
      var base = data.offers[0], path = String(base.url || "").split("?")[0], added = 0;
      rows.forEach(function (v) {
        if (have[v.id]) return;
        var o = JSON.parse(JSON.stringify(base));
        ["sku", "mpn", "gtin", "gtin8", "gtin12", "gtin13", "gtin14"].forEach(function (k) { delete o[k]; });
        o.url = path + "?variant=" + v.id;
        o.price = (v.p / 100).toFixed(2);
        o.availability = "https://schema.org/" + (v.a ? "InStock" : "OutOfStock");
        var sku = skuFor(v);
        if (sku) o.sku = sku;
        data.offers.push(o); have[v.id] = 1; added++;
      });
      if (added) el.textContent = JSON.stringify(data);
    } catch (e) {}
  }

  /* ------------------------------------------------------------- start */
  var touched = false;
  ["click", "keydown", "input"].forEach(function (ev) {
    root.addEventListener(ev, function (e) { if (e.isTrusted) touched = true; }, true);
  });
  var deepWait = false;
  if (deepLink) {
    /* a deep link to a model outside the first 250 variants waits for the table */
    var dm = matchIn(M, wantM), dl = matchIn(L, wantL) || state.l;
    if (complete || !dm || modelInfo(dl, dm).ex) applyDeepLink();
    else { deepWait = true; pickFor(dl, "", matchIn(C, wantC) || state.c); if (shot) shot.classList.add("is-loading"); }
  } else if (!cfg.picked) {
    pickFor(state.l, "", state.c);
  }
  /* once the whole table is in (now, or after a retry): the deep link, the
     "From" prices, the sold-out marks, the missing Offers */
  onData.push(function () {
    if (shot) shot.classList.remove("is-loading");
    hideWait();
    if (deepLink && (deepWait || !touched)) { deepWait = false; applyDeepLink(); }
    render({ url: deepLink || urlTouched });
    fillBelow();
    completeOffers();
  });
  ensureData().then(null, function () { if (shot && deepWait) shot.classList.remove("is-loading"); });
  render({ url: deepLink || !!(state.ini || state.sp || state.gift || state.prio || state.logo) });
  fixRating();
  fillBelow();
  window.addEventListener("pageshow", function (e) { if (e.persisted) render({ image: false, url: false }); });
  /* endless animations nobody can see (the delivery strip's pulsing dot, the support tile's sway, a caret) stop drawing
     frames while they are off screen, so a tap never waits behind them (kit 1.6.1, INP) */
  if (GCX.calm) GCX.calm();
})();
